var barba = require('@barba/core');
var css = require('@barba/css');

import { fabric } from "fabric";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

import sal from 'sal.js';


import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);





window.onload = function() {



  if (document.querySelector('.news__trigger') != null) {
    document.querySelector('.news__trigger__mobile').addEventListener('click', open_news);
    document.querySelector('.news__trigger').addEventListener('click', open_news);
    document.querySelector('.news__overlay__close').addEventListener('click', open_news);

    document.querySelector('.news__overlay__bg').addEventListener('click', open_news);


    function open_news() {
      document.querySelector('.news__overlay__bg').classList.toggle('active');
      document.querySelector('.news__overlay').classList.toggle('active');
    }
  }

// Add the novalidate attribute when the JS loads
  var forms = document.querySelectorAll('.validate');
  for (var i = 0; i < forms.length; i++) {
    forms[i].setAttribute('novalidate', true);
  }


// Validate the field
  var hasError = function (field) {

    // Don't validate submits, buttons, file and reset inputs, and disabled fields
    if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return;

    // Get validity
    var validity = field.validity;

    // If valid, return null
    if (validity.valid) return;

    // If field is required and empty
    if (validity.valueMissing) return 'Please fill out this field.';

    // If not the right type
    if (validity.typeMismatch) {

      // Email
      if (field.type === 'email') return 'Please enter an email address.';

      // URL
      if (field.type === 'url') return 'Please enter a URL.';

    }

    // If too short
    if (validity.tooShort) return 'Please lengthen this text to ' + field.getAttribute('minLength') + ' characters or more. You are currently using ' + field.value.length + ' characters.';

    // If too long
    if (validity.tooLong) return 'Please shorten this text to no more than ' + field.getAttribute('maxLength') + ' characters. You are currently using ' + field.value.length + ' characters.';

    // If pattern doesn't match
    if (validity.patternMismatch) {

      // If pattern info is included, return custom error
      if (field.hasAttribute('title')) return field.getAttribute('title');

      // Otherwise, generic error
      return 'Please match the requested format.';

    }

    // If number input isn't a number
    if (validity.badInput) return 'Please enter a number.';

    // If a number value doesn't match the step interval
    if (validity.stepMismatch) return 'Please select a valid value.';

    // If a number field is over the max
    if (validity.rangeOverflow) return 'Please select a value that is no more than ' + field.getAttribute('max') + '.';

    // If a number field is below the min
    if (validity.rangeUnderflow) return 'Please select a value that is no less than ' + field.getAttribute('min') + '.';

    // If all else fails, return a generic catchall error
    return 'The value you entered for this field is invalid.';

  };


// Show an error message
  var showError = function (field, error) {

    // Add error class to field
    field.classList.add('error');

    // If the field is a radio button and part of a group, error all and get the last item in the group
    if (field.type === 'radio' && field.name) {
      var group = field.form.querySelectorAll('[name="' + field.name + '"]');
      if (group.length > 0) {
        for (var i = 0; i < group.length; i++) {
          group[i].classList.add('error');
        }
        field = group[group.length - 1];
      }
    }

    // Get field id or name
    var id = field.id || field.name;
    if (!id) return;

    // Check if error message field already exists
    // If not, create one
    var message = field.form.querySelector('.error-message#error-for-' + id );
    if (!message) {
      message = document.createElement('div');
      message.className = 'error-message';
      message.id = 'error-for-' + id;

      // If the field is a radio button or checkbox, insert error after the label
      var label;
      if (field.type === 'radio' || field.type ==='checkbox') {
        label = field.form.querySelector('label[for="' + id + '"]') || field.parentNode;
        if (label) {
          label.parentNode.insertBefore( message, label.nextSibling );
        }
      }

      // Otherwise, insert it after the field
      if (!label) {
        field.parentNode.insertBefore( message, field.nextSibling );
      }

    }

    // Add ARIA role to the field
    field.setAttribute('aria-describedby', 'error-for-' + id);

    // Update error message
    message.innerHTML = error;

    // Show error message
    message.style.display = 'block';
    message.style.visibility = 'visible';

  };


// Remove the error message
  var removeError = function (field) {

    // Remove error class to field
    field.classList.remove('error');

    // Remove ARIA role from the field
    field.removeAttribute('aria-describedby');

    // If the field is a radio button and part of a group, remove error from all and get the last item in the group
    if (field.type === 'radio' && field.name) {
      var group = field.form.querySelectorAll('[name="' + field.name + '"]');
      if (group.length > 0) {
        for (var i = 0; i < group.length; i++) {
          group[i].classList.remove('error');
        }
        field = group[group.length - 1];
      }
    }

    // Get field id or name
    var id = field.id || field.name;
    if (!id) return;


    // Check if an error message is in the DOM
    var message = field.form.querySelector('.error-message#error-for-' + id + '');
    if (!message) return;

    // If so, hide it
    message.innerHTML = '';
    message.style.display = 'none';
    message.style.visibility = 'hidden';

  };

// Serialize the form data into a query string
// Forked and modified from https://stackoverflow.com/a/30153391/1293256
  var serialize = function (form) {

    // Setup our serialized data
    var serialized = '';

    // Loop through each field in the form
    for (i = 0; i < form.elements.length; i++) {

      var field = form.elements[i];

      // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
      if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

      // Convert field data to a query string
      if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
        serialized += '&' + encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value);
      }
    }

    return serialized;

  };

// Display the form status
  window.displayMailChimpStatus = function (data) {

    // Make sure the data is in the right format and that there's a status container
    if (!data.result || !data.msg || !mcStatus ) return;

    // Update our status message
    mcStatus.innerHTML = data.msg;

    // If error, add error class
    if (data.result === 'error') {
      mcStatus.classList.remove('success-message');
      mcStatus.classList.add('error-message');
      return;
    }

    // Otherwise, add success class
    mcStatus.classList.remove('error-message');
    mcStatus.classList.add('success-message');
   // document.querySelector('.success-message').innerHTML = 'Thank you! Check your inbox!'
    if (document.querySelector('.news__overlay').classList.contains("active")) {
      document.querySelector('.news__overlay__inner').classList.add('hide');
      document.querySelector('.news__overlay__success').classList.add('active');
      document.querySelector('.news__overlay').classList.add('red-bg');
    }
    else {
      document.querySelector('.mail-footer .success').classList.remove('hide');
      document.querySelector('.mail-footer .normal').classList.add('hide');
      document.querySelector('.mail-footer form').classList.add('hide');
    }
  };



  var downloadButton = document.getElementById("download-button");

  downloadButton.addEventListener("click", function() {
    var fileUrl = "https://www.saschakrischock.com/dev/wordpress/cooltura/wp-content/uploads/2023/02/COOLTURA-2022-EOY-REPORT.pdf";
    var fileName = "cooltura_report.pdf";
    var link = document.createElement("a");
    link.href = fileUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  });

// Submit the form
  var submitMailChimpForm = function (form) {

    // Get the Submit URL
    var url = form.getAttribute('action');
    url = url.replace('/post?u=', '/post-json?u=');
    url += serialize(form) + '&c=displayMailChimpStatus';

    // Create script with url and callback (if specified)
    var ref = window.document.getElementsByTagName( 'script' )[ 0 ];
    var script = window.document.createElement( 'script' );
    script.src = url;

    // Create a global variable for the status container
    window.mcStatus = form.querySelector('.mc-status');

    // Insert script tag into the DOM (append to <head>)
    ref.parentNode.insertBefore( script, ref );

    // After the script is loaded (and executed), remove it
    script.onload = function () {
      this.remove();
    };

  };

// Listen to all blur events
  document.addEventListener('blur', function (event) {

    // Only run if the field is in a form to be validated
    if (!event.target.form.classList.contains('validate')) return;

    // Validate the field
    var error = hasError(event.target);

    // If there's an error, show it
    if (error) {
      showError(event.target, error);
      return;
    }

    // Otherwise, remove any existing error message
    removeError(event.target);

  }, true);


// Check all fields on submit
  document.addEventListener('submit', function (event) {

    // Only run on forms flagged for validation
    if (!event.target.classList.contains('validate')) return;

    // Prevent form from submitting
    event.preventDefault();

    // Get all of the form elements
    var fields = event.target.elements;

    // Validate each field
    // Store the first field with an error to a variable so we can bring it into focus later
    var error, hasErrors;
    for (var i = 0; i < fields.length; i++) {
      error = hasError(fields[i]);
      if (error) {
        showError(fields[i], error);
        if (!hasErrors) {
          hasErrors = fields[i];
        }
      }
    }

    // If there are errrors, don't submit form and focus on first element with error
    if (hasErrors) {
      hasErrors.focus();
    }

    // Otherwise, let the form submit normally
    // You could also bolt in an Ajax form submit process here
    submitMailChimpForm(event.target);

  }, false);


  //cursor
 /* for (var a = 1; a < 11; a++) {
    var elem = document.createElement('div');
    elem.id = 'trail' + a;
    elem.classList.add('trail');

    var two = '<path d="M3.72655 5.78374L8.02824 7.28573C8.77445 7.54292 9.56454 7.02854 9.56454 6.28783V2.06991C9.56454 1.48352 10.0803 1 10.7058 1H14.2283C14.8538 1 15.3696 1.48352 15.3696 2.06991V6.27754C15.3696 7.01825 16.1597 7.54292 16.9059 7.27544L21.2515 5.77345C21.8441 5.5677 22.5025 5.85575 22.7219 6.41128L23.9291 9.50785C24.1485 10.0634 23.8413 10.6806 23.2487 10.8761L18.7056 12.4398C17.9704 12.697 17.718 13.5612 18.2228 14.127L21.7782 18.1289C22.1843 18.5815 22.1184 19.2502 21.6356 19.6309L18.947 21.7501C18.4642 22.1307 17.7509 22.069 17.3449 21.6164L13.3724 17.1824C12.9115 16.6783 12.0775 16.6783 11.6276 17.1824L7.65514 21.6164C7.24911 22.069 6.5358 22.1307 6.05296 21.7501L3.36443 19.6309C2.88159 19.2502 2.81574 18.5815 3.22177 18.1289L6.77722 14.127C7.28201 13.5612 7.02962 12.697 6.29438 12.4398L1.7513 10.8761C1.15873 10.6703 0.851469 10.0634 1.07094 9.50785L2.27805 6.41128C2.49752 5.85575 3.15594 5.5677 3.74852 5.77345L3.72655 5.78374Z" fill="#000"/>'
    var svgfragment = '<svg width="50" height="46" viewBox="0 0 50 46">' + two + '</svg>';
    elem.innerHTML = svgfragment;
    document.body.appendChild(elem);
  }


  var lastPos = [
        [0, 0]
      ],
      trailStarted = false,
      lastEvent = 0;

// Update array of past cursor positions
  var updateTrail = (positions) => {
    positions.forEach((e, i, a) => {
      document.getElementById('trail' + (i + 1)).style.left = e[0] + 'px';
      document.getElementById('trail' + (i + 1)).style.top = e[1] + 'px';
    });
  };
// Set last event so render function can push to array
  document.addEventListener('mousemove', (e) => {
    lastEvent = e;
    if (!trailStarted) {
      renderTrail(e);
      trailStarted = true;
    }
  });
// Render the trail using the new positions
  var renderTrail = (e) => {
    lastPos.push([e.clientX, e.clientY]);
    if (lastPos.length > 10) {
      lastPos.shift();
    }
    updateTrail(lastPos);

    requestAnimationFrame(() => {
      renderTrail(lastEvent)
    });
  };
*/



  document.querySelector('.menu__trigger').addEventListener('click', open_mobile_menu);


  function open_mobile_menu() {
    document.querySelector('.header').classList.toggle('black');
    document.querySelector('.menu__trigger').classList.toggle('active');
    document.querySelector('.mobile__menu').classList.toggle('active');
    document.body.classList.toggle('black');
  }



/*
  (function emojiCursor() {

    var possibleEmoji = ["blue", "green", "red"]
    var width = window.innerWidth;
    var height = window.innerHeight;
    var cursor = {x: width/2, y: width/2};
    var particles = [];

    function init() {
      bindEvents();
      loop();
    }


    function bindEvents() {
      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('touchmove', onTouchMove);
      document.addEventListener('touchstart', onTouchMove);

      window.addEventListener('resize', onWindowResize);
    }

    function onWindowResize(e) {
      width = window.innerWidth;
      height = window.innerHeight;
    }

    function onTouchMove(e) {
      if( e.touches.length > 0 ) {
        for( var i = 0; i < e.touches.length; i++ ) {
          addParticle( e.touches[i].clientX, e.touches[i].clientY, possibleEmoji[Math.floor(Math.random()*possibleEmoji.length)]);
        }
      }
    }

    function onMouseMove(e) {
      cursor.x = e.clientX;
      cursor.y = e.clientY;


      addParticle( cursor.x, cursor.y, possibleEmoji[Math.floor(Math.random()*possibleEmoji.length)]);

    }

    function addParticle(x, y, character) {

      var particle = new Particle();
      particle.init(x, y, character);
      particles.push(particle);

    }

    function updateParticles() {


      for( var i = 0; i < particles.length; i++ ) {
        particles[i].update();
      }


      for( var i = particles.length -1; i >= 0; i-- ) {
        if( particles[i].lifeSpan < 0 ) {
          particles[i].die();
          particles.splice(i, 1);
        }
      }

    }

    function loop() {
      requestAnimationFrame(loop);
      updateParticles();
    }


    function Particle() {

      this.lifeSpan = 120; //ms
      this.initialStyles ={
        "position": "fixed",
        "display": "block",
        "pointerEvents": "none",
        "z-index": "10",
        "fontSize": "16px",
        "will-change": "transform"
      };


      this.init = function(x, y, character) {

        this.velocity = {
          x:  (Math.random() < 0.5 ? -1 : 1) * (Math.random() / 2),
          y: 1
        };

        this.position = {x: x - 10, y: y - 20};

        this.element = document.createElement('span');
        this.element.classList.add(character);
        this.element.classList.add('cursor-item');


        var two = '<path d="M3.72655 5.78374L8.02824 7.28573C8.77445 7.54292 9.56454 7.02854 9.56454 6.28783V2.06991C9.56454 1.48352 10.0803 1 10.7058 1H14.2283C14.8538 1 15.3696 1.48352 15.3696 2.06991V6.27754C15.3696 7.01825 16.1597 7.54292 16.9059 7.27544L21.2515 5.77345C21.8441 5.5677 22.5025 5.85575 22.7219 6.41128L23.9291 9.50785C24.1485 10.0634 23.8413 10.6806 23.2487 10.8761L18.7056 12.4398C17.9704 12.697 17.718 13.5612 18.2228 14.127L21.7782 18.1289C22.1843 18.5815 22.1184 19.2502 21.6356 19.6309L18.947 21.7501C18.4642 22.1307 17.7509 22.069 17.3449 21.6164L13.3724 17.1824C12.9115 16.6783 12.0775 16.6783 11.6276 17.1824L7.65514 21.6164C7.24911 22.069 6.5358 22.1307 6.05296 21.7501L3.36443 19.6309C2.88159 19.2502 2.81574 18.5815 3.22177 18.1289L6.77722 14.127C7.28201 13.5612 7.02962 12.697 6.29438 12.4398L1.7513 10.8761C1.15873 10.6703 0.851469 10.0634 1.07094 9.50785L2.27805 6.41128C2.49752 5.85575 3.15594 5.5677 3.74852 5.77345L3.72655 5.78374Z" fill="#000"/>'



        var svgfragment = '<svg width="50" height="46" viewBox="0 0 50 46">' + two + '</svg>';
        this.element.innerHTML = svgfragment;
        applyProperties(this.element, this.initialStyles);
        this.update();

        document.body.appendChild(this.element);

      };

      this.update = function() {
        this.position.x += this.velocity.x;
        this.position.y += this.velocity.y;
        this.lifeSpan--;

        this.element.style.transform = "translate3d(" + this.position.x + "px," + this.position.y + "px,0) scale(" + (this.lifeSpan / 120) + ")";
      }

      this.die = function() {
        this.element.parentNode.removeChild(this.element);
      }

    }

    function applyProperties( target, properties ) {
      for( var key in properties ) {
        target.style[ key ] = properties[ key ];
      }
    }

    init();
  })();
*/


 // butter.init();

 document.querySelector('.loader').classList.add('inactive');




 /*
  if (document.querySelector('.cursor__container') != null) {
    window.addEventListener('scroll', function() {
      scrollRotate_cursor();
    });

    function scrollRotate_cursor() {
      let cursor = document.querySelector(".cursor__pointer__drag svg");
      cursor.style.transform = "rotate(-" + window.pageYOffset / 10 + "deg)";
    }
  }
*/


  /*
  document.onmousemove = function (event) {
    var x = event.clientX;
    var y = event.clientY;
    console.log(x + "," + y);
    document.querySelector(".cursor__wrapper").style.transform = `translate(${x}px, ${y}px)`;
    document.querySelector(".cursor__pointer").style.transform = `translate(${x}px, ${y}px)`;
    document.querySelector(".cursor__pointer__drag").style.transform = `translate(${x}px, ${y}px)`;

  };

*/

  function all() {




    if (document.querySelector('.services__content') != null) {

      const colors = ["red-hover", "green-hover", "blue-hover"];
      let randomColors = [...colors]; // create a copy of the colors array


      const marqueeWrappers = document.querySelectorAll(".marquee__wrapper");
      marqueeWrappers.forEach(wrapper => {
        wrapper.addEventListener("mouseleave", handleMouseLeave);
        wrapper.addEventListener("mouseenter", handleMouseEnter);
      });

      function handleMouseEnter(event) {
        const wrapper = event.currentTarget;
        const arrowPath = wrapper.querySelector(".marquee__arrow svg path");

        if (randomColors.length === 0) {
          randomColors = [...colors]; // reset the randomColors array if all colors have been used
        }

        const index = Math.floor(Math.random() * randomColors.length);
        const color = randomColors.splice(index, 1)[0];

        wrapper.classList.add(color);
        //arrowPath.style.fill = color;
      }


      function handleMouseLeave(event) {
        const service = event.currentTarget;
        const arrow = service.querySelector(".marquee__arrow svg path");
        service.classList.remove('red-hover');
        service.classList.remove('green-hover');
        service.classList.remove('blue-hover');
      }
    }

    if (document.querySelector('.typewrite') != null) {




      if (document.querySelector('.image_contact') != null) {

        var contactDivs = document.getElementsByClassName("contact__show");
      var contactImage = document.querySelector(".image_contact");

      for (var i = 0; i < contactDivs.length; i++) {
        contactDivs[i].addEventListener("mouseover", function() {
          contactImage.style.opacity = "1";
        });
        contactDivs[i].addEventListener("mouseout", function() {
          contactImage.style.opacity = "0";
        });
      }
      }

      // typewriter
      var TxtType = function (el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
      };

      TxtType.prototype.tick = function () {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
          this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
          this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

        var that = this;
        var delta = 200 - 1 * 100;

        if (this.isDeleting) {
          delta /= 2;
        }

        if (!this.isDeleting && this.txt === fullTxt) {
          delta = this.period;
          this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
          this.isDeleting = false;
          this.loopNum++;
          delta = 450;
        }

        setTimeout(function () {
          that.tick();
        }, delta);
      };



        var elements = document.getElementsByClassName('typewrite');
        for (var i = 0; i < elements.length; i++) {
          var toRotate = elements[i].getAttribute('data-type');
          var period = elements[i].getAttribute('data-period');
          if (toRotate) {
            new TxtType(elements[i], JSON.parse(toRotate), period);
          }
        }
    }

    if (document.querySelector('.rotate') != null) {
      window.onscroll = function () {
        scrollRotate();
      };

      function scrollRotate() {
        let sticker_green = document.querySelector(".rotate");
        sticker_green.style.transform = "rotate(" + window.pageYOffset/2 + "deg)";

      }
    }



    const swiper = new Swiper('.swiper-quotes', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return ('0' + number).slice(-2);
        },
        formatFractionTotal: function (number) {
          return ('0' + number).slice(-2);
        },
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' +
              '<span class="divider">–</span>' +
              '<span class="' + totalClass + '"></span>';
        }
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

    });


    if (document.querySelector('.text__wrapper') != null) {
      // select the header element
      const body = document.body;
      const header = document.querySelector('.header');

// select the full height section element
      const textSection = document.querySelector('.text__trigger');


// create an intersection observer instance
      const observer = new IntersectionObserver((entries) => {
        // if the full height section intersects with the top of the viewport
        if (entries[0].isIntersecting) {
          // add the "green" class to the header
          body.classList.add('black-bg');
          header.classList.add('black-bg-header');
        } else {
          // otherwise, remove the "green" class from the header
          body.classList.remove('black-bg');
          header.classList.remove('black-bg-header');
        }
      });

// start observing the full height section
      observer.observe(textSection);
    }

    if (document.querySelector('.swiper-container-off') != null) {
      // select the header element
      const body = document.body;
      const header = document.querySelector('.header');

// select the full height section element
      const textSection = document.querySelector('.swiper-container-off');


// create an intersection observer instance
      const observer = new IntersectionObserver((entries) => {
        // if the full height section intersects with the top of the viewport
        if (entries[0].isIntersecting) {
          // add the "green" class to the header
          body.classList.add('black-bg-2');
          header.classList.add('black-bg-2-header');
        } else {
          // otherwise, remove the "green" class from the header
          body.classList.remove('black-bg-2');
          header.classList.remove('black-bg-2-header');
        }
      });

// start observing the full height section
      observer.observe(textSection);
    }


    if (document.querySelector('.white-trigger') != null) {
      // select the header element
      const body = document.body;
      const header = document.querySelector('.header');

// select the full height section element
      const textSection = document.querySelector('.white-trigger');
      // create an intersection observer instance
      const observer = new IntersectionObserver((entries) => {
        // if the full height section intersects with the top of the viewport
        if (entries[0].isIntersecting) {
          // add the "green" class to the header
          body.classList.add('white-bg');
          header.classList.add('white-bg-header');
        } else {
          // otherwise, remove the "green" class from the header
          body.classList.remove('white-bg');
          header.classList.remove('white-bg-header');
        }
      });


// start observing the full height section
      observer.observe(textSection);
    }


    if (document.querySelector('.pink-trigger') != null) {
      // select the header element
      const body = document.body;
      const header = document.querySelector('.header');

// select the full height section element
      const pinkSection = document.querySelector('.pink-trigger');
      // create an intersection observer instance
      const observer = new IntersectionObserver((entries) => {
        // if the full height section intersects with the top of the viewport
        if (entries[0].isIntersecting) {
          // add the "green" class to the header
          body.classList.add('pink-bg');
          header.classList.add('pink-bg-header');
        } else {
          // otherwise, remove the "green" class from the header
          body.classList.remove('pink-bg');
          header.classList.remove('pink-bg-header');
        }
      });


// start observing the full height section
      observer.observe(pinkSection);
    }


    if (document.querySelector('.red-trigger') != null) {
      // select the header element
      const body = document.body;
      const header = document.querySelector('.header');

// select the full height section element
      const redSection = document.querySelector('.red-trigger');
      // create an intersection observer instance
      const observer = new IntersectionObserver((entries) => {
        // if the full height section intersects with the top of the viewport
        if (entries[0].isIntersecting) {
          // add the "green" class to the header
          body.classList.add('red-bg');
          header.classList.add('red-bg-header');
        } else {
          // otherwise, remove the "green" class from the header
          body.classList.remove('red-bg');
          header.classList.remove('red-bg-header');
        }
      });


// start observing the full height section
      observer.observe(redSection);
    }


    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        document.body.classList.add("bottom");
      } else {
        document.body.classList.remove("bottom");
      }
    });

    const target = document.querySelector(".mail-footer-trigger");
    observer.observe(target);





    if (document.querySelector('.swiper-quotes') != null) {
      // select the header element
      const header = document.querySelector('.header');
      const body = document.body;

// select the full height section element
      const fullHeightSection = document.querySelector('.green-trigger');

// create an intersection observer instance
      const observer = new IntersectionObserver((entries) => {
        // if the full height section intersects with the top of the viewport
        if (entries[0].isIntersecting) {
          // add the "green" class to the header
          body.classList.add('green-bg');
          header.classList.add('green-bg');
        } else {
          // otherwise, remove the "green" class from the header
          header.classList.remove('green-bg');
          body.classList.remove('green-bg');
        }
      });

// start observing the full height section
      observer.observe(fullHeightSection);
    }


    if (document.querySelector('.about__middle') != null) {
      // select the header element
      const body = document.body;
      const header = document.querySelector('.header');

// select the full height section element
      const trigger = document.querySelector('.about__middle__trigger');


// create an intersection observer instance
      const observer = new IntersectionObserver((entries) => {
        // if the full height section intersects with the top of the viewport
        if (entries[0].isIntersecting) {
          // add the "green" class to the header
          body.classList.add('black-bg');
          header.classList.add('black-bg-header');
        } else {
          // otherwise, remove the "green" class from the header
          body.classList.remove('black-bg');
          header.classList.remove('black-bg-header');
        }
      });

// start observing the full height section
      observer.observe(trigger);
    }



    /*
    var a = document.querySelectorAll('a');

    a.forEach(item => {
      item.addEventListener('mouseover', () => {
        document.querySelector('.cursor__pointer__drag svg').classList.add('hover');
      });
      item.addEventListener('mouseleave', () => {
        document.querySelector('.cursor__pointer__drag svg').classList.remove('hover');
      });
    });*/

    if (document.querySelector('canvas') != null) {


      /**
       * fabric.brushes - A collection of brushes for fabric.js (version 4 and up).
       *
       * Made by Arjan Haverkamp, https://www.webgear.nl
       * Copyright 2021 Arjan Haverkamp
       * MIT Licensed
       * @version 1.0 - 2021-06-02
       * @url https://github.com/av01d/fabric-brushes
       *
       * Inspiration sources:
       * - https://github.com/tennisonchan/fabric-brush
       * - https://mrdoob.com/projects/harmony/
       * - http://perfectionkills.com/exploring-canvas-drawing-techniques/
       */

      (function(fabric) {

        /**
         * Trim a canvas. Returns the left-top coordinate where trimming began.
         * @param {canvas} canvas A canvas element to trim. This element will be trimmed (reference).
         * @returns {Object} Left-top coordinate of trimmed area. Example: {x:65, y:104}
         * @see: https://stackoverflow.com/a/22267731/3360038
         */
        fabric.util.trimCanvas = function(canvas) {
          var ctx = canvas.getContext('2d'),
              w = canvas.width,
              h = canvas.height,
              pix = {x:[], y:[]}, n,
              imageData = ctx.getImageData(0,0,w,h),
              fn = function(a,b) { return a-b };

          for (var y = 0; y < h; y++) {
            for (var x = 0; x < w; x++) {
              if (imageData.data[((y * w + x) * 4)+3] > 0) {
                pix.x.push(x);
                pix.y.push(y);
              }
            }
          }
          pix.x.sort(fn);
          pix.y.sort(fn);
          n = pix.x.length-1;

          //if (n == -1) {
          //	// Nothing to trim... empty canvas?
          //}

          w = pix.x[n] - pix.x[0];
          h = pix.y[n] - pix.y[0];
          var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h);

          canvas.width = w;
          canvas.height = h;
          ctx.putImageData(cut, 0, 0);

          return {x:pix.x[0], y:pix.y[0]};
        }

        /**
         * Extract r,g,b,a components from any valid color.
         * Returns {undefined} when color cannot be parsed.
         *
         * @param {number} color Any color string (named, hex, rgb, rgba)
         * @returns {(Array|undefined)} Example: [0,128,255,1]
         * @see https://gist.github.com/oriadam/396a4beaaad465ca921618f2f2444d49
         */
        fabric.util.colorValues = function(color) {
          if (!color) { return; }
          if (color.toLowerCase() === 'transparent') { return [0, 0, 0, 0]; }
          if (color[0] === '#') {
            if (color.length < 7) {
              // convert #RGB and #RGBA to #RRGGBB and #RRGGBBAA
              color = '#' + color[1] + color[1] + color[2] + color[2] + color[3] + color[3] + (color.length > 4 ? color[4] + color[4] : '');
            }
            return [parseInt(color.substr(1, 2), 16),
              parseInt(color.substr(3, 2), 16),
              parseInt(color.substr(5, 2), 16),
              color.length > 7 ? parseInt(color.substr(7, 2), 16)/255 : 1];
          }
          if (color.indexOf('rgb') === -1) {
            // convert named colors
            var tempElem = document.body.appendChild(document.createElement('fictum')); // intentionally use unknown tag to lower chances of css rule override with !important
            var flag = 'rgb(1, 2, 3)'; // this flag tested on chrome 59, ff 53, ie9, ie10, ie11, edge 14
            tempElem.style.color = flag;
            if (tempElem.style.color !== flag) {
              return; // color set failed - some monstrous css rule is probably taking over the color of our object
            }
            tempElem.style.color = color;
            if (tempElem.style.color === flag || tempElem.style.color === '') {
              return; // color parse failed
            }
            color = getComputedStyle(tempElem).color;
            document.body.removeChild(tempElem);
          }
          if (color.indexOf('rgb') === 0)	{
            if (color.indexOf('rgba') === -1) {
              color += ',1'; // convert 'rgb(R,G,B)' to 'rgb(R,G,B)A' which looks awful but will pass the regxep below
            }
            return color.match(/[\.\d]+/g).map(function(a)	{
              return +a
            });
          }
        }

        fabric.Point.prototype.angleBetween = function(that) {
          return Math.atan2( this.x - that.x, this.y - that.y);
        };

        fabric.Point.prototype.normalize = function(thickness) {
          if (null === thickness || undefined === thickness) {
            thickness = 1;
          }

          var length = this.distanceFrom({ x: 0, y: 0 });

          if (length > 0) {
            this.x = this.x / length * thickness;
            this.y = this.y / length * thickness;
          }

          return this;
        };

        /**
         * Convert a brush drawing on the upperCanvas to an image on the fabric canvas.
         * This makes the drawing editable, it can be moved, rotated, scaled, skewed etc.
         */
        fabric.BaseBrush.prototype.convertToImg = function() {
          var pixelRatio = this.canvas.getRetinaScaling(),
              c = fabric.util.copyCanvasElement(this.canvas.upperCanvasEl),
              xy = fabric.util.trimCanvas(c),
              img = new fabric.Image(c);
          this.canvas.add(img);
          img.set({left:xy.x/pixelRatio,top:xy.y/pixelRatio,'scaleX':1/pixelRatio,'scaleY':1/pixelRatio}).setCoords();
          this.canvas.clearContext(this.canvas.contextTop);
        }

        fabric.util.getRandom = function(max, min) {
          min = min ? min : 0;
          return Math.random() * ((max ? max : 1) - min) + min;
        };

        fabric.util.clamp = function (n, max, min) {
          if (typeof min !== 'number') { min = 0; }
          return n > max ? max : n < min ? min : n;
        };

        fabric.Stroke = fabric.util.createClass(fabric.Object,{
          color: null,
          inkAmount: null,
          lineWidth: null,

          _point: null,
          _lastPoint: null,
          _currentLineWidth: null,

          initialize: function(ctx, pointer, range, color, lineWidth, inkAmount) {
            var rx = fabric.util.getRandom(range),
                c = fabric.util.getRandom(Math.PI * 2),
                c0 = fabric.util.getRandom(Math.PI * 2),
                x0 = rx * Math.sin(c0),
                y0 = rx / 2 * Math.cos(c0),
                cos = Math.cos(c),
                sin = Math.sin(c);

            this.ctx = ctx;
            this.color = color;
            this._point = new fabric.Point(pointer.x + x0 * cos - y0 * sin, pointer.y + x0 * sin + y0 * cos);
            this.lineWidth = lineWidth;
            this.inkAmount = inkAmount;
            this._currentLineWidth = lineWidth;

            ctx.lineCap = 'round';
          },

          update: function(pointer, subtractPoint, distance) {
            this._lastPoint = fabric.util.object.clone(this._point);
            this._point = this._point.addEquals({ x: subtractPoint.x, y: subtractPoint.y });

            var n = this.inkAmount / (distance + 1),
                per = (n > 0.3 ? 0.2 : n < 0 ? 0 : n);
            this._currentLineWidth = this.lineWidth * per;
          },

          draw: function() {
            var ctx = this.ctx;
            ctx.save();
            this.line(ctx, this._lastPoint, this._point, this.color, this._currentLineWidth);
            ctx.restore();
          },

          line: function(ctx, point1, point2, color, lineWidth) {
            ctx.strokeStyle = color;
            ctx.lineWidth = lineWidth;
            ctx.beginPath();
            ctx.moveTo(point1.x, point1.y);
            ctx.lineTo(point2.x, point2.y);
            ctx.stroke();
          }
        });

        /**
         * CrayonBrush
         * Based on code by Tennison Chan.
         */
        fabric.CrayonBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 0.6,
          width: 75,

          _baseWidth: 75,
          _inkAmount: 10,
          _latestStrokeLength: 0,
          _point: null,
          _sep: 5,
          _size: 0,
          _latest: null,
          _drawn: false,

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || canvas.contextTop.globalAlpha;
            this._point = new fabric.Point(0, 0);
          },

          onMouseDown: function(pointer) {
            this.canvas.contextTop.globalAlpha = this.opacity;
            this._size = this.width / 2 + this._baseWidth;
            this._drawn = false;
            this.set(pointer);
            this.update(pointer);
            this.draw(this.canvas.contextTop);
          },

          onMouseMove: function(pointer) {
            this.update(pointer);
            this.draw(this.canvas.contextTop);
          },

          onMouseUp: function() {
            if (this._drawn) {
              this.convertToImg();
            }
            this._latest = null;
            this._latestStrokeLength = 0;
            this.canvas.contextTop.globalAlpha = 1;
          },

          set: function(p) {
            if (this._latest) {
              this._latest.setFromPoint(this._point);
            } else {
              this._latest = new fabric.Point(p.x, p.y);
            }
            fabric.Point.prototype.setFromPoint.call(this._point, p);
          },

          update: function(p) {
            this.set(p);
            this._latestStrokeLength = this._point.subtract(this._latest).distanceFrom({ x: 0, y: 0 });
          },

          draw: function(ctx) {
            var i, j, p, r, c, x, y, w, h, v, s, stepNum, dotSize, dotNum, range;

            v = this._point.subtract(this._latest);
            s = Math.ceil(this._size / 2);
            stepNum = Math.floor(v.distanceFrom({ x: 0, y: 0 }) / s) + 1;
            v.normalize(s);

            dotSize = this._sep * fabric.util.clamp(this._inkAmount / this._latestStrokeLength * 3, 0.4, 0.01);
            dotNum = Math.ceil(this._size * this._sep);

            range = this._size / 2;

            ctx.save();
            ctx.fillStyle = this.color;
            ctx.beginPath();


/*
            var pointer = canvas.getPointer(event.e);
            var posX = pointer.x;
            var posY = pointer.y;

            for(var spray = 0, len = 100; spray < len; spray++) {

              var angle = Math.random() * Math.PI *2;
              var radius = Math.random() * 100;

              ctx.arc( posX+ Math.cos(angle) * radius, posY + Math.sin(angle) * radius, 0.75 + Math.floor(Math.random() * 0.5), 0, Math.PI * 2);
              ctx.fill();
              ctx.closePath();
            }
*/

            for (i = 0; i < 200; i++) {
              for (j = 0; j < stepNum; j++) {
                p = this._latest.add(v.multiply(j));
                r = fabric.util.getRandom(range);
                c = fabric.util.getRandom(Math.PI * 2);
                w = fabric.util.getRandom(dotSize, dotSize / 2);
                h = fabric.util.getRandom(dotSize, dotSize / 2);
                x = p.x + r * Math.sin(c) - w / 2;
                y = p.y + r * Math.cos(c) - h / 2;
                ctx.rect(x, y, w, h);
              }
            }
            ctx.fill();
            ctx.restore();
            this._drawn = true;
          },

          _render: function() {}

        }); // End CrayonBrush

        /**
         * FurBrush
         * Based on code by Mr. Doob.
         */
        fabric.FurBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 1,

          _count: 0,
          _points: [],

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || 1;
          },

          onMouseDown: function(pointer) {
            this._points = [pointer];
            this._count = 0;

            var ctx = this.canvas.contextTop,
                color = fabric.util.colorValues(this.color);

            ctx.strokeStyle = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + (0.1 * this.opacity) + ')';
            ctx.lineWidth = this.width;

            this._points.push(pointer);
          },

          onMouseMove: function(pointer) {
            this._points.push(pointer);

            var i, dx, dy, d,
                ctx = this.canvas.contextTop,
                points = this._points,
                lastPoint = points[points.length - 2];

            ctx.beginPath();
            ctx.moveTo(lastPoint.x, lastPoint.y);
            ctx.lineTo(pointer.x, pointer.y);
            ctx.stroke();

            for (i = 0; i < this._points.length; i++) {
              dx = this._points[i].x - this._points[this._count].x;
              dy = this._points[i].y - this._points[this._count].y;
              d = dx * dx + dy * dy;

              if (d < 2000 && Math.random() > d / 2000)	{
                ctx.beginPath();
                ctx.moveTo(pointer.x + (dx * 0.5), pointer.y + (dy * 0.5));
                ctx.lineTo(pointer.x - (dx * 0.5), pointer.y - (dy * 0.5));
                ctx.stroke();
              }
            }

            this._count++;
          },

          onMouseUp: function(pointer) {
            if (this._count > 0) {
              this.convertToImg();
            }
          },

          _render: function() {}
        }); // End FurBrush

        /**
         * InkBrush
         * Based on code by Tennison Chan.
         */
        fabric.InkBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 30,

          _baseWidth: 20,
          _inkAmount: 7,
          _lastPoint: null,
          _point: null,
          _range: 10,
          _strokes: null,

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || canvas.contextTop.globalAlpha;

            this._point = new fabric.Point();
          },

          _render: function(pointer) {
            var len, i, point = this.setPointer(pointer),
                subtractPoint = point.subtract(this._lastPoint),
                distance = point.distanceFrom(this._lastPoint),
                stroke;

            for (i = 0, len = this._strokes.length; i < len; i++) {
              stroke = this._strokes[i];
              stroke.update(point, subtractPoint, distance);
              stroke.draw();
            }

            if (distance > 30) {
              this.drawSplash(point, this._inkAmount);
            }
          },

          onMouseDown: function(pointer) {
            this.canvas.contextTop.globalAlpha = this.opacity;
            this._resetTip(pointer);
          },

          onMouseMove: function(pointer) {
            if (this.canvas._isCurrentlyDrawing) {
              this._render(pointer);
            }
          },

          onMouseUp: function() {
            this.convertToImg();
            this.canvas.contextTop.globalAlpha = 1;
          },

          drawSplash: function(pointer, maxSize) {
            var c, r, i, point,
                ctx = this.canvas.contextTop,
                num = fabric.util.getRandom(12),
                range = maxSize * 10,
                color = this.color;

            ctx.save();
            for (i = 0; i < num; i++) {
              r = fabric.util.getRandom(range, 1);
              c = fabric.util.getRandom(Math.PI * 2);
              point = new fabric.Point(pointer.x + r * Math.sin(c), pointer.y + r * Math.cos(c));

              ctx.fillStyle = color;
              ctx.beginPath();
              ctx.arc(point.x, point.y, fabric.util.getRandom(maxSize) / 2, 0, Math.PI * 2, false);
              ctx.fill();
            }
            ctx.restore();
          },

          setPointer: function(pointer) {
            var point = new fabric.Point(pointer.x, pointer.y);

            this._lastPoint = fabric.util.object.clone(this._point);
            this._point = point;

            return point;
          },

          _resetTip: function(pointer) {
            var len, i, point = this.setPointer(pointer);

            this._strokes = [];
            this.size = this.width / 5 + this._baseWidth;
            this._range = this.size / 2;

            for (i = 0, len = this.size; i < len; i++) {
              this._strokes[i] = new fabric.Stroke(this.canvas.contextTop, point, this._range, this.color, this.width, this._inkAmount);
            }
          }
        }); // End InkBrush

        /**
         * LongfurBrush
         * Based on code by Mr. Doob.
         */
        fabric.LongfurBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 1,

          _count: 0,
          _points: [],

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || 1;
          },

          onMouseDown: function(pointer) {
            this._points = [pointer];
            this._count = 0;

            var ctx = this.canvas.contextTop,
                color = fabric.util.colorValues(this.color);

            //ctx.globalCompositeOperation = 'source-over';
            ctx.strokeStyle = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + (0.05 * this.opacity) + ')';
            ctx.lineWidth = this.width;
          },

          onMouseMove: function(pointer) {
            this._points.push(pointer);

            var i, dx, dy, d, size,
                ctx = this.canvas.contextTop,
                points = this._points;

            for (i = 0; i < this._points.length; i++) {
              size = -Math.random();

              dx = this._points[i].x - this._points[this._count].x;
              dy = this._points[i].y - this._points[this._count].y;
              d = dx * dx + dy * dy;

              if (d < 4000 && Math.random() > d / 4000)	{
                ctx.beginPath();
                ctx.moveTo(this._points[this._count].x + (dx * size), this._points[this._count].y + (dy * size));
                ctx.lineTo(this._points[i].x - (dx * size) + Math.random() * 2, this._points[i].y - (dy * size) + Math.random() * 2);
                ctx.stroke();
              }
            }

            this._count++;
          },

          onMouseUp: function(pointer) {
            if (this._count > 0) {
              this.convertToImg();
            }
          },

          _render: function() {}
        }); // End LongfurBrush

        /**
         * MarkerBrush
         * Based on code by Tennison Chan.
         */
        fabric.MarkerBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 30,

          _baseWidth: 10,
          _lastPoint: null,
          _lineWidth: 3,
          _point: null,
          _size: 0,

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || canvas.contextTop.globalAlpha;
            this.canvas.contextTop.globalAlpha = this.opacity;
            this._point = new fabric.Point();

            this.canvas.contextTop.lineJoin = 'round';
            this.canvas.contextTop.lineCap = 'round';
          },

          _render: function(pointer) {
            var ctx, lineWidthDiff, i, len;

            ctx = this.canvas.contextTop;

            ctx.beginPath();

            for(i = 0, len = (this._size / this._lineWidth) / 2; i < len; i++) {
              lineWidthDiff = (this._lineWidth - 1) * i;

              ctx.globalAlpha = 0.8 * this.opacity;
              ctx.moveTo(this._lastPoint.x + lineWidthDiff, this._lastPoint.y + lineWidthDiff);
              ctx.lineTo(pointer.x + lineWidthDiff, pointer.y + lineWidthDiff);
              ctx.stroke();
            }

            this._lastPoint = new fabric.Point(pointer.x, pointer.y);
          },

          onMouseDown: function(pointer) {
            this._lastPoint = pointer;
            this.canvas.contextTop.strokeStyle = this.color;
            this.canvas.contextTop.lineWidth = this._lineWidth;
            this._size = this.width + this._baseWidth;
          },

          onMouseMove: function(pointer) {
            if (this.canvas._isCurrentlyDrawing) {
              this._render(pointer);
            }
          },

          onMouseUp: function() {
            this.canvas.contextTop.globalAlpha = this.opacity;
            this.canvas.contextTop.globalAlpha = 1;
          }
        }); // End MarkerBrush

        /**
         * RibbonBrush
         * Based on code by Mr. Doob.
         */
        fabric.RibbonBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 1,

          _nrPainters: 50,
          _painters: [],
          _lastPoint: null,
          _interval: null,

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || 1;

            for (var i = 0; i < this._nrPainters; i++) {
              this._painters.push({ dx:this.canvas.width / 2, dy:this.canvas.height / 2, ax:0, ay:0, div:.1, ease:Math.random() * .2 + .6 });
            }
          },

          update: function() {
            var ctx = this.canvas.contextTop, painters = this._painters;
            for (var i = 0; i < painters.length; i++)	{
              ctx.beginPath();
              ctx.moveTo(painters[i].dx, painters[i].dy);
              painters[i].dx -= painters[i].ax = (painters[i].ax + (painters[i].dx - this._lastPoint.x) * painters[i].div) * painters[i].ease;
              painters[i].dy -= painters[i].ay = (painters[i].ay + (painters[i].dy - this._lastPoint.y) * painters[i].div) * painters[i].ease;
              ctx.lineTo(painters[i].dx, painters[i].dy);
              ctx.stroke();
            }
          },

          onMouseDown: function(pointer) {
            var ctx = this.canvas.contextTop,
                color = fabric.util.colorValues(this.color);

            this._painters = [];
            for (var i = 0; i < this._nrPainters; i++) {
              this._painters.push({ dx:this.canvas.width / 2, dy:this.canvas.height / 2, ax:0, ay:0, div:.1, ease:Math.random() * .2 + .6 });
            }

            this._lastPoint = pointer;

            //ctx.globalCompositeOperation = 'source-over';
            ctx.strokeStyle = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + (0.05 * this.opacity) + ')';
            ctx.lineWidth = this.width;

            for (var i = 0; i < this._nrPainters; i++) {
              this._painters[i].dx = pointer.x;
              this._painters[i].dy = pointer.y;
            }

            var self = this;
            this._interval = setInterval(function() { self.update() }, 1000/60);
          },

          onMouseMove: function(pointer) {
            this._lastPoint = pointer;
          },

          onMouseUp: function(pointer) {
            clearInterval(this._interval);
            this.convertToImg();
          },

          _render: function() {}
        }); // End RibbonBrush

        /**
         * ShadedBrush
         * Based on code by Mr. Doob.
         */
        fabric.ShadedBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: .1,
          width: 1,
          shadeDistance: 1000,

          _points: [],

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || .3;
            this.shadeDistance = opt.shadeDistance || 1000;
          },

          onMouseDown: function(pointer) {
            this._points = [pointer];

            var ctx = this.canvas.contextTop,
                color = fabric.util.colorValues(this.color);

            ctx.strokeStyle = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + this.opacity + ')';
            ctx.lineWidth = this.width;
            ctx.lineJoin = ctx.lineCap = 'round';
          },

          onMouseMove: function(pointer) {
            this._points.push(pointer);

            var ctx = this.canvas.contextTop,
                points = this._points;

            ctx.beginPath();
            ctx.moveTo(points[points.length - 2].x, points[points.length - 2].y);
            ctx.lineTo(points[points.length - 1].x, points[points.length - 1].y);
            ctx.stroke();

            for (var i = 0, len = points.length; i < len; i++) {
              dx = points[i].x - points[points.length-1].x;
              dy = points[i].y - points[points.length-1].y;
              d = dx * dx + dy * dy;

              if (d < this.shadeDistance) {
                ctx.beginPath();
                ctx.moveTo( points[points.length-1].x + (dx * 0.2), points[points.length-1].y + (dy * 0.2));
                ctx.lineTo( points[i].x - (dx * 0.2), points[i].y - (dy * 0.2));
                ctx.stroke();
              }
            }
          },

          onMouseUp: function(pointer) {
            if (this._points.length > 1) {
              this.convertToImg();
            }
          },

          _render: function() {}
        }); // End ShadedBrush

        /**
         * SketchyBrush
         * Based on code by Mr. Doob.
         */
        fabric.SketchyBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 1,

          _count: 0,
          _points: [],

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || 1;
          },

          onMouseDown: function(pointer) {
            this._count = 0;
            this._points = [pointer];

            var ctx = this.canvas.contextTop,
                color = fabric.util.colorValues(this.color);
            //ctx.globalCompositeOperation = 'source-over';
            ctx.strokeStyle = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + (0.05 * this.opacity) + ')';
            ctx.lineWidth = this.width;
          },

          onMouseMove: function(pointer) {
            this._points.push(pointer);

            var i, dx, dy, d, factor = .3 * this.width,
                ctx = this.canvas.contextTop,
                points = this._points,
                count = this._count,
                lastPoint = points[points.length - 2];

            ctx.beginPath();
            ctx.moveTo(lastPoint.x, lastPoint.y);
            ctx.lineTo(pointer.x, pointer.y);
            ctx.stroke();

            for (i = 0; i < points.length; i++) {
              dx = points[i].x - points[count].x;
              dy = points[i].y - points[count].y;
              d = dx * dx + dy * dy;

              if (d < 4000 && Math.random() > d / 2000)	{
                ctx.beginPath();
                ctx.moveTo(points[count].x + (dx * factor), points[count].y + (dy * factor));
                ctx.lineTo(points[i].x - (dx * factor), points[i].y - (dy * factor));
                ctx.stroke();
              }
            }

            this._count++;
          },

          onMouseUp: function(pointer) {
            if (this._count > 0) {
              this.convertToImg();
            }
          },

          _render: function() {}
        }); // End SketchyBrush

        /**
         * SpraypaintBrush
         * Based on code by Tennison Chan.
         */
        fabric.SpraypaintBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 30,

          _baseWidth: 40,
          _inkAmount: 0,
          _interval: 20,
          _lastPoint: null,
          _point: null,
          brush: null,
          sprayBrushDataUrl: 'data:image/png;base64,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',

          initialize: function(canvas, opt) {
            var self = this;
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.opacity = opt.opacity || canvas.contextTop.globalAlpha;
            this.color = opt.color || canvas.freeDrawingBrush.color;

            this.canvas.contextTop.lineJoin = 'round';
            this.canvas.contextTop.lineCap = 'round';

            this._reset();

            fabric.Image.fromURL(this.sprayBrushDataUrl, function(brush) {
              self.brush = brush;
              self.brush.filters = [];
              self._setColor(self.color || this.color);
            }, { crossOrigin: 'anonymous' });
          },


          _setColor: function(color) {
            this.color = color;
            this.brush.filters[0] = new fabric.Image.filters.BlendColor({ color:color, alpha:1, mode:'tint' });
            this.brush.applyFilters();
          },

          onMouseDown: function(pointer) {
            this.canvas.contextTop.globalAlpha = this.opacity;
            this._point = new fabric.Point(pointer.x, pointer.y);
            this._lastPoint = this._point;

            this.size = this.width + this._baseWidth;
            this._inkAmount = 0;

            this._setColor(this.color);
            this._render();
          },

          onMouseMove: function(pointer) {
            this._lastPoint = this._point;
            this._point = new fabric.Point(pointer.x, pointer.y);
          },

          onMouseUp: function() {
            var self = this;
            setTimeout(function() {
              self.convertToImg();
              self._reset();
            }, this._interval);
          },

          _render: function() {
            var self = this;

            function draw() {
              var point, distance, angle, amount, x, y;

              point = new fabric.Point(self._point.x || 0, self._point.y || 0);
              distance = point.distanceFrom(self._lastPoint);
              angle = point.angleBetween(self._lastPoint);
              amount = (100 / self.size) / (Math.pow(distance, 2) + 1);

              self._inkAmount += amount;
              self._inkAmount = Math.max(self._inkAmount - distance / 10, 0);

              x = self._lastPoint.x + Math.sin(angle) - self.size / 2;
              y = self._lastPoint.y + Math.cos(angle) - self.size / 2;
              self.canvas.contextTop.drawImage(self.brush._element, x, y, self.size, self.size);

              if (self.canvas._isCurrentlyDrawing) {
                setTimeout(draw, self._interval);
              } else {
                self._reset();
              }
            }

            draw();
          },

          _reset: function() {
            this._point = null;
            this._lastPoint = null;
            this.canvas.contextTop.globalAlpha = 1;
          }
        }); // End SpraypaintBrush

        /**
         * SquaresBrush
         * Based on code by Mr. Doob.
         */
        fabric.SquaresBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          bgColor: '#fff',
          opacity: 1,
          width: 1,

          _lastPoint: null,
          _drawn: false,

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.bgColor = opt.bgColor || '#fff';
            this.opacity = opt.opacity || canvas.contextTop.globalAlpha;
          },

          onMouseDown: function(pointer) {
            var ctx = this.canvas.contextTop,
                color = fabric.util.colorValues(this.color),
                bgColor = fabric.util.colorValues(this.bgColor);

            this._lastPoint = pointer;
            this._drawn = false;

            //ctx.globalCompositeOperation = 'source-over';
            this.canvas.contextTop.globalAlpha = this.opacity;
            ctx.fillStyle = 'rgba(' + bgColor[0] + ',' + bgColor[1] + ',' + bgColor[2] + ',' + bgColor[3] + ')';
            ctx.strokeStyle = 'rgba(' + color[0] + ',' + color[1] + ',' + color[2] + ',' + color[3] + ')';
            ctx.lineWidth = this.width;
          },

          onMouseMove: function(pointer) {
            var ctx = this.canvas.contextTop,
                dx = pointer.x - this._lastPoint.x,
                dy = pointer.y - this._lastPoint.y,
                angle = 1.57079633,
                px = Math.cos(angle) * dx - Math.sin(angle) * dy,
                py = Math.sin(angle) * dx + Math.cos(angle) * dy;

            ctx.beginPath();
            ctx.moveTo(this._lastPoint.x - px, this._lastPoint.y - py);
            ctx.lineTo(this._lastPoint.x + px, this._lastPoint.y + py);
            ctx.lineTo(pointer.x + px, pointer.y + py);
            ctx.lineTo(pointer.x - px, pointer.y - py);
            ctx.lineTo(this._lastPoint.x - px, this._lastPoint.y - py);
            ctx.fill();
            ctx.stroke();

            this._lastPoint = pointer;
            this._drawn = true;
          },

          onMouseUp: function(pointer) {
            if (this._drawn) {
              this.convertToImg();
            }
            this.canvas.contextTop.globalAlpha = 1;
          },

          _render: function() {}
        }); // End SquaresBrush

        /**
         * WebBrush
         * Based on code by Mr. Doob.
         */
        fabric.WebBrush = fabric.util.createClass(fabric.BaseBrush, {
          color: '#000',
          opacity: 1,
          width: 1,

          _count: 0,
          _points: [],

          initialize: function(canvas, opt) {
            opt = opt || {};

            this.canvas = canvas;
            this.width = opt.width || canvas.freeDrawingBrush.width;
            this.color = opt.color || canvas.freeDrawingBrush.color;
            this.opacity = opt.opacity || 1;
          },

          onMouseDown: function(pointer) {
            this._points = [pointer];
            this._count = 0;
            this._colorValues = fabric.util.colorValues(this.color);
          },

          onMouseMove: function(pointer) {
            this._points.push(pointer);

            var ctx = this.canvas.contextTop,
                points = this._points,
                lastPoint = points[points.length - 2],
                colorValues = this._colorValues,
                i, dx, dy, d;

            ctx.lineWidth = this.width;
            ctx.strokeStyle = 'rgba(' + colorValues[0] + ',' + colorValues[1] + ',' + colorValues[2] + ',' + (.5 * this.opacity) + ')';

            ctx.beginPath();
            ctx.moveTo(lastPoint.x, lastPoint.y);
            ctx.lineTo(pointer.x, pointer.y);
            ctx.stroke();

            ctx.strokeStyle = 'rgba(' + colorValues[0] + ',' + colorValues[1] + ',' + colorValues[2] + ',' + (.1 * this.opacity) + ')';

            for (i = 0; i < points.length; i++) {
              dx = points[i].x - points[this._count].x;
              dy = points[i].y - points[this._count].y;
              d = dx * dx + dy * dy;

              if (d < 2500 && Math.random() > .9) {
                ctx.beginPath();
                ctx.moveTo(points[this._count].x, points[this._count].y);
                ctx.lineTo(points[i].x, points[i].y);
                ctx.stroke();
              }
            }
            this._count++;
          },

          onMouseUp: function(pointer) {
            if (this._count > 0) {
              this.convertToImg();
            }
          },

          _render: function() {}
        }); // End WebBrush

      })(typeof fabric !== 'undefined' ? fabric : require('fabric').fabric);



      ///

        var $ = function(id){return document.getElementById(id)};

        var canvas = new fabric.Canvas('c', {
          isDrawingMode: true
        });

        if (document.documentElement.clientWidth <= 768) {
          if (document.querySelector('#matter') !== null) {
          document.querySelector('#matter').style.height = document.documentElement.clientHeight - 100 + "px";
          canvas.setHeight(document.documentElement.clientHeight - 100);
          }
        }
        else {
          canvas.setHeight(document.documentElement.clientHeight);
        }
        canvas.setWidth(window.innerWidth);





      document.querySelector('.save').onclick = function() {

        canvas.backgroundColor="#ffffff";



        const sampleUrl = 'https://www.saschakrischock.com/dev/wordpress/cooltura/wp-content/uploads/text_small_3.png';

        var imgInstance = new fabric.Image.fromURL(sampleUrl, function(oImg) {
          oImg.set({
            left: 30,
            top: 30,
            opacity: 1
          });

          canvas.add(oImg);

          setTimeout(function () {
            const dataURL = canvas.toDataURL({
              width: canvas.width,
              height: canvas.height,
              left: 0,
              top: 0,
              format: 'png',
            });




            const link = document.createElement('a');
            link.download = 'image.png';
            link.href = dataURL;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            canvas.remove(oImg);
          }, 1);
        });





      };

        fabric.Object.prototype.transparentCorners = false;



        var drawingColorEl = $('drawing-color'),
            drawingShadowColorEl = $('drawing-shadow-color'),
            drawingLineWidthEl = $('drawing-line-width')
         //   clearEl = $('clear-canvas');


       // clearEl.onclick = function() { canvas.clear() };

      /*  drawingModeEl.onclick = function() {
          canvas.isDrawingMode = !canvas.isDrawingMode;
          if (canvas.isDrawingMode) {
            drawingModeEl.innerHTML = 'Cancel drawing mode';
            drawingOptionsEl.style.display = '';
          }
          else {
            drawingModeEl.innerHTML = 'Enter drawing mode';
            drawingOptionsEl.style.display = 'none';
          }
        };*/

      document.querySelector('.clear').addEventListener('click', clear);

      function clear() {
        canvas.clear()
      };

      document.querySelector('.canvas__color__red').addEventListener('click', color_red);
      document.querySelector('.canvas__color__green').addEventListener('click', color_green);
      document.querySelector('.canvas__color__blue').addEventListener('click', color_blue);

      function color_red() {
        document.querySelector('.canvas__color__red').classList.add('active');
        document.querySelector('.canvas__color__blue').classList.remove('active');
        document.querySelector('.canvas__color__green').classList.remove('active');
        drawingColorEl.value = '#F64414';
        var brush = canvas.freeDrawingBrush;
        brush.color = '#F64414';
      }

      function color_green() {
        document.querySelector('.canvas__color__green').classList.add('active');
        document.querySelector('.canvas__color__blue').classList.remove('active');
        document.querySelector('.canvas__color__red').classList.remove('active');
        drawingColorEl.value = '#C0FF33';
        var brush = canvas.freeDrawingBrush;
        brush.color = '#C0FF33';
      }

      function color_blue() {
        document.querySelector('.canvas__color__blue').classList.add('active');
        document.querySelector('.canvas__color__green').classList.remove('active');
        document.querySelector('.canvas__color__red').classList.remove('active');
        drawingColorEl.value = '#B19AFF';
        var brush = canvas.freeDrawingBrush;
        brush.color = '#B19AFF';
      }

      document.querySelector('.canvas__pen').addEventListener('click', pencil);


      function pencil() {
        document.querySelector('.canvas__pen').classList.add('active');
        document.querySelector('.canvas__spray').classList.remove('active');

        canvas.freeDrawingBrush = new fabric['Pencil' + 'Brush'](canvas);
        canvas.freeDrawingBrush.width = 75;
        canvas.freeDrawingBrush.color = drawingColorEl.value;
      }

      document.querySelector('.canvas__spray').addEventListener('click', spray);


      function spray() {
        document.querySelector('.canvas__spray').classList.add('active');
        document.querySelector('.canvas__pen').classList.remove('active');

        canvas.freeDrawingBrush = new fabric['Crayon' + 'Brush'](canvas);
        // canvas.freeDrawingBrush.density = 100;
        canvas.freeDrawingBrush.density = 50;
        canvas.freeDrawingBrush.dotWidth = 0.5;
        canvas.freeDrawingBrush.color = drawingColorEl.value;

        canvas.freeDrawingBrush.width = 75;
        canvas.freeDrawingBrush.shadow = new fabric.Shadow({
          blur: 20,
          offsetX: 5,
          offsetY: 5,
          affectStroke: true,
          color: drawingShadowColorEl.value,
        });
      }

      if (fabric.PatternBrush) {
          var vLinePatternBrush = new fabric.PatternBrush(canvas);
          vLinePatternBrush.getPatternSrc = function() {

            var patternCanvas = fabric.document.createElement('canvas');
            patternCanvas.width = patternCanvas.height = 10;
            var ctx = patternCanvas.getContext('2d');

            ctx.strokeStyle = this.color;
            ctx.lineWidth = 5;
            ctx.beginPath();
            ctx.moveTo(0, 5);
            ctx.lineTo(10, 5);
            ctx.closePath();
            ctx.stroke();

            return patternCanvas;
          };

          var hLinePatternBrush = new fabric.PatternBrush(canvas);
          hLinePatternBrush.getPatternSrc = function() {

            var patternCanvas = fabric.document.createElement('canvas');
            patternCanvas.width = patternCanvas.height = 10;
            var ctx = patternCanvas.getContext('2d');

            ctx.strokeStyle = this.color;
            ctx.lineWidth = 5;
            ctx.beginPath();
            ctx.moveTo(5, 0);
            ctx.lineTo(5, 10);
            ctx.closePath();
            ctx.stroke();

            return patternCanvas;
          };

          var squarePatternBrush = new fabric.PatternBrush(canvas);
          squarePatternBrush.getPatternSrc = function() {

            var squareWidth = 10, squareDistance = 2;

            var patternCanvas = fabric.document.createElement('canvas');
            patternCanvas.width = patternCanvas.height = squareWidth + squareDistance;
            var ctx = patternCanvas.getContext('2d');

            ctx.fillStyle = this.color;
            ctx.fillRect(0, 0, squareWidth, squareWidth);

            return patternCanvas;
          };

          var diamondPatternBrush = new fabric.PatternBrush(canvas);
          diamondPatternBrush.getPatternSrc = function() {

            var squareWidth = 10, squareDistance = 5;
            var patternCanvas = fabric.document.createElement('canvas');
            var rect = new fabric.Rect({
              width: squareWidth,
              height: squareWidth,
              angle: 45,
              fill: this.color
            });

            var canvasWidth = rect.getBoundingRect().width;

            patternCanvas.width = patternCanvas.height = canvasWidth + squareDistance;
            rect.set({ left: canvasWidth / 2, top: canvasWidth / 2 });

            var ctx = patternCanvas.getContext('2d');
            rect.render(ctx);

            return patternCanvas;
          };

          var img = new Image();
          img.src = '../assets/honey_im_subtle.png';

          var texturePatternBrush = new fabric.PatternBrush(canvas);
          texturePatternBrush.source = img;
        }

        $('drawing-mode-selector').onchange = function() {

          if (this.value === 'hline') {
            canvas.freeDrawingBrush = vLinePatternBrush;
          }
          else if (this.value === 'vline') {
            canvas.freeDrawingBrush = hLinePatternBrush;
          }
          else if (this.value === 'square') {
            canvas.freeDrawingBrush = squarePatternBrush;
          }
          else if (this.value === 'diamond') {
            canvas.freeDrawingBrush = diamondPatternBrush;
          }
          else if (this.value === 'texture') {
            canvas.freeDrawingBrush = texturePatternBrush;
          }
          else {
            canvas.freeDrawingBrush = new fabric[this.value + 'Brush'](canvas);
            canvas.freeDrawingBrush.width = 100;
          }

          if (canvas.freeDrawingBrush) {
            var brush = canvas.freeDrawingBrush;
            brush.color = drawingColorEl.value;
            if (brush.getPatternSrc) {
              brush.source = brush.getPatternSrc.call(brush);
            }
            brush.width = parseInt(drawingLineWidthEl.value, 10) || 1;
            brush.shadow = new fabric.Shadow({
              blur: 1,
              offsetX: 0,
              offsetY: 0,
              affectStroke: true,
              color: drawingShadowColorEl.value,
            });

          }
        };

        drawingColorEl.onchange = function() {
          var brush = canvas.freeDrawingBrush;
          brush.color = this.value;
          if (brush.getPatternSrc) {
            brush.source = brush.getPatternSrc.call(brush);
          }
        };
        drawingShadowColorEl.onchange = function() {
          canvas.freeDrawingBrush.shadow.color = this.value;
        };
        drawingLineWidthEl.onchange = function() {
          canvas.freeDrawingBrush.width = parseInt(this.value, 10) || 1;
          this.previousSibling.innerHTML = this.value;
        };


        if (canvas.freeDrawingBrush) {
          canvas.freeDrawingBrush = new fabric['Crayon' + 'Brush'](canvas);
         // canvas.freeDrawingBrush.density = 100;
          canvas.freeDrawingBrush.density = 50;
          canvas.freeDrawingBrush.dotWidth = 0.5;
          canvas.freeDrawingBrush.color = drawingColorEl.value;

          canvas.freeDrawingBrush.width = 100;
          canvas.freeDrawingBrush.shadow = new fabric.Shadow({
            blur: 20,
            offsetX: 5,
            offsetY: 5,
            affectStroke: true,
            color: drawingShadowColorEl.value,
          });
        }



        /*

      var docWidth = window.innerWidth,
          slidesWidth = document.querySelector('#imgs').offsetWidth,
          rangeX = slidesWidth - docWidth,
          images = document.querySelector('#imgs');

      window.addEventListener('resize', function(){
        var docWidth = window.innerWidth,
            slidesWidth = document.querySelector('#imgs').offsetWidth
        rangeX = slidesWidth - docWidth;
      })

      window.addEventListener('mousemove', function(e){
        var mouseX = e.pageX,
            percentMouse = mouseX * 100 / docWidth,
            offset = percentMouse / 100 * slidesWidth - percentMouse / 104 * docWidth;

        images.style.transform = 'translate3d(' + -offset + 'px,0,0)';
      });
*/


      /*
      window.onscroll = function () {
        console.log('innerheight:' + window.innerHeight + 'scrollY:' + window.scrollY);
        // We add pageYOffset for compatibility with IE.
        if (window.scrollY >= 1 && window.scrollY < (window.innerHeight * 2)) {
          document.querySelector(".header").classList.add('white-home');
        }
        else {
          document.querySelector(".header").classList.remove('white-home');
        }
      };*/
    }


    if (document.querySelector('.about__wrapper') != null) {

      console.log('about');

    /*  document.querySelector('.about__banner').addEventListener("mouseover", function (event) {
        console.log('about__in');
        const cursor_items = document.querySelectorAll('.cursor-item');
        Array.from(cursor_items).forEach(function (cursor_item) {
          cursor_item.classList.add('hide-cursor');
        });



      });
      document.querySelector('.about__banner').addEventListener("mouseleave", function (event) {

        const cursor_items = document.querySelectorAll('.cursor-item');
        Array.from(cursor_items).forEach(function (cursor_item) {
          cursor_item.classList.remove('hide-cursor');
        });

      });*/


      // body element
      const body = document.body;

      // helper functions
      const MathUtils = {
        // linear interpolation
        lerp: (a, b, n) => (1 - n) * a + n * b,
        // distance between two points
        distance: (x1, y1, x2, y2) => Math.hypot(x2 - x1, y2 - y1),
        // Random float
        getRandomFloat: (min, max) => (Math.random() * (max - min) + min).toFixed(2)
      }

      // calculate the viewport size
      let winsize;
      const calcWinsize = () => winsize = {width: window.innerWidth, height: window.innerHeight};
      calcWinsize();
      // and recalculate on resize
      window.addEventListener('resize', calcWinsize);

      // get the mouse position
      const getMousePos = (ev) => {
        let posx = 0;
        let posy = 0;
        if (!ev) ev = window.event;
        if (ev.pageX || ev.pageY) {
          posx = ev.pageX;
          posy = ev.pageY;
        } else if (ev.clientX || ev.clientY) {
          posx = ev.clientX + body.scrollLeft + docEl.scrollLeft;
          posy = ev.clientY + body.scrollTop + docEl.scrollTop;
        }
        return {x: posx, y: posy};
      }

      // mousePos: current mouse position
      // cacheMousePos: previous mouse position
      // lastMousePos: last last recorded mouse position (at the time the last image was shown)
      let mousePos = {x: 0, y: 0},
          lastMousePos = {x: 0, y: 0},
          cacheMousePos = {x: 0, y: 0};

      // update the mouse position
      window.addEventListener('mousemove', ev => mousePos = getMousePos(ev));

      // gets the distance from the current mouse position to the last recorded mouse position
      const getMouseDistance = () => MathUtils.distance(mousePos.x, mousePos.y, lastMousePos.x, lastMousePos.y);

      class Image {
        constructor(el) {
          this.DOM = {el: el};
          // image deafult styles
          this.defaultStyle = {
            rotation: 0,
            x: 0,
            y: 0,
            opacity: 0
          };
          // get sizes/position
          this.getRect();
          // init/bind events
          this.initEvents();
        }

        initEvents() {
          // on resize get updated sizes/position
          window.addEventListener('resize', () => this.resize());
        }

        resize() {
          // reset styles
          gsap.set(this.DOM.el, this.defaultStyle);
          // get sizes/position
          this.getRect();
        }

        getRect() {
          this.rect = this.DOM.el.getBoundingClientRect();
        }

        isActive() {
          // check if image is animating or if it's visible
          return gsap.isTweening(this.DOM.el) || this.DOM.el.style.opacity != 0;
        }

        setRatio() {
          this.DOM.el.style.setProperty('--img-maxwidth', `${MathUtils.getRandomFloat(150, 350)}px`);
          // get sizes/position
          this.getRect();
        }
      }

      class ImageTrail {
        constructor() {
          // images container
          this.DOM = {content: document.querySelector('.content__about')};
          // array of Image objs, one per image element
          this.images = [];
          [...this.DOM.content.querySelectorAll('img')].forEach(img => this.images.push(new Image(img)));
          // total number of images
          this.imagesTotal = this.images.length;
          // upcoming image index
          this.imgPosition = 0;
          // zIndex value to apply to the upcoming image
          this.zIndexVal = 1;
          // mouse distance required to show the next image
          this.threshold = 150;
          // render the images
          requestAnimationFrame(() => this.render());
        }

        render() {
          // get distance between the current mouse position and the position of the previous image
          let distance = getMouseDistance();
          // cache previous mouse position
          cacheMousePos.x = MathUtils.lerp(cacheMousePos.x || mousePos.x, mousePos.x, 0.1);
          cacheMousePos.y = MathUtils.lerp(cacheMousePos.y || mousePos.y, mousePos.y, 0.1);

          // if the mouse moved more than [this.threshold] then show the next image
          if (distance > this.threshold) {
            this.showNextImage();

            ++this.zIndexVal;
            this.imgPosition = this.imgPosition < this.imagesTotal - 1 ? this.imgPosition + 1 : 0;

            lastMousePos = mousePos;
          }

          // check when mousemove stops and all images are inactive (not visible and not animating)
          let isIdle = true;
          for (let img of this.images) {
             if (img.isActive()) {
              isIdle = false;
              break;
            }
          }
          // reset z-index initial value
          if (isIdle && this.zIndexVal !== 1) {
            this.zIndexVal = 1;
          }

          // loop..
          requestAnimationFrame(() => this.render());
        }

        showNextImage() {
          // show image at position [this.imgPosition]
          const img = this.images[this.imgPosition];
          img.setRatio();
          // kill any tween on the image
          gsap.killTweensOf(img.DOM.el);

          new gsap.timeline()
              // show the image
              .set(img.DOM.el, {
                startAt: {opacity: 0},
                opacity: 1,
                rotation: 0,
                zIndex: this.zIndexVal,
                x: cacheMousePos.x - img.rect.width / 2,
                y: cacheMousePos.y - img.rect.height / 2
              }, 0)
              // animate position
              .to(img.DOM.el, 1.6, {
                // ease: Power1.easeOut,
                x: mousePos.x - img.rect.width / 2,
                y: mousePos.y - img.rect.height / 2
              }, 0)
              // then make it disappear
              .to(img.DOM.el, 0.8, {
                //  ease: Power1.easeOut,
                opacity: 0
              }, 0.6)
              // translate down the image
              .to(img.DOM.el, 1, {
                //   ease: Quint.easeOut,
                x: `+=${MathUtils.getRandomFloat(-1 * (winsize.width + img.rect.width / 2), winsize.width + img.rect.width / 2)}`,
                y: `+=${MathUtils.getRandomFloat(-1 * (winsize.height + img.rect.height / 2), winsize.height + img.rect.height / 2)}`,
                rotation: MathUtils.getRandomFloat(-40, 40)
              }, 0.6);
        }
      }

      /***********************************/
      /********** Preload stuff **********/

      new ImageTrail();
    }

    if(document.querySelector('.about__wrapper') != null) {
      const project_items = document.querySelectorAll('.about__team__grid__item');
      Array.from(project_items).forEach(function (item) {
        item.addEventListener("mouseenter", function (event) {


          document.querySelector('.about__team__grid__pre__title__name').textContent = item.getAttribute('data-name') + ',';
          document.querySelector('.about__team__grid__pre__title__profession').textContent = item.getAttribute('data-profession');

        });
        item.addEventListener("mouseleave", function (event) {

          document.querySelector('.about__team__grid__pre__title__name').textContent = '';
          document.querySelector('.about__team__grid__pre__title__profession').textContent = '';
        });

      });
    }


    sal({
      once: false,
    });



    window.addEventListener('popstate', function (event) {

      if (location.hash === '#list' && document.querySelector('.projects__wrapper') != null ) {
        document.querySelector('.projects__header').classList.add('list-active');
        document.querySelector('.projects__header').classList.remove('gallery-active');

        document.querySelector('.projects__wrapper__list').classList.add('active');
        document.querySelector('.projects__wrapper__grid').classList.remove('active');

      }
      if (location.hash === '#gallery' && document.querySelector('.projects__wrapper') != null ) {
        document.querySelector('.projects__header').classList.remove('list-active');
        document.querySelector('.projects__header').classList.add('gallery-active');

        document.querySelector('.projects__wrapper__list').classList.remove('active');
        document.querySelector('.projects__wrapper__grid').classList.add('active');
      }
    });

    if (location.hash === '#list' && document.querySelector('.projects__wrapper') != null ) {
      document.querySelector('.projects__header').classList.add('list-active');
      document.querySelector('.projects__header').classList.remove('gallery-active');

      document.querySelector('.projects__wrapper__list').classList.add('active');
      document.querySelector('.projects__wrapper__grid').classList.remove('active');

    }
    if (location.hash === '#gallery' && document.querySelector('.projects__wrapper') != null ) {
      document.querySelector('.projects__header').classList.remove('list-active');
      document.querySelector('.projects__header').classList.add('gallery-active');

      document.querySelector('.projects__wrapper__list').classList.remove('active');
      document.querySelector('.projects__wrapper__grid').classList.add('active');
    }


    if (document.querySelector('.swiper-container') != null) {
      document.querySelector('.swiper-container').addEventListener("mouseenter", function () {
   //     document.querySelector('.cursor__wrapper').classList.add('active');
   //     document.querySelector('.cursor__pointer__drag').classList.add('active');
  //      document.querySelector('.cursor__pointer').classList.add('active');

      });

      document.querySelector('.swiper-container').addEventListener("mouseleave", function () {
      //  document.querySelector('.cursor__wrapper').classList.remove('active');
      //  document.querySelector('.cursor__pointer__drag').classList.remove('active');
     //   document.querySelector('.cursor__pointer').classList.remove('active');


      });
    }

    if (document.querySelector('.swiper-container-off') != null) {

      var slide = gsap.timeline({
        scrollTrigger: {
          trigger: ".swiper-container-off",
          start: "-100%",
          end: "-1%",
          scrub: true,
          pin: false,
          //    pinSpacing: false,
         // markers: true,
          id: "scrub",

        }

      });

      slide.from(".slide-stagger", {
        duration: 2,
        x: 0,
        y: 1000,
        stagger: 0.1
      });




      let sections = gsap.utils.toArray(".swiper-slides");


      if (window.innerWidth > 768 ) {
      gsap.to(sections, {
        x: -(document.querySelector('.off-wrapper').offsetWidth - window.innerWidth / 1.025),
        ease: "none",
        scrollTrigger: {
          trigger: ".swiper-container-off",
          pin: true,
          //  start: 0,
          scrub: 1,
          //  markers: true,
          // snap: 1 / (sections.length - 1),
          // base vertical scrolling on how wide the container is so it feels more natural.
          end: "bottom",
        }
      });
    }
      else {
        gsap.to(sections, {
          x: -(document.querySelector('.off-wrapper').offsetWidth * 7 - window.innerWidth / 1.4),
          ease: "none",
          scrollTrigger: {
            trigger: ".swiper-container-off",
            pin: true,
            //  start: 0,
            scrub: 1,
            //  markers: true,
            // snap: 1 / (sections.length - 1),
            // base vertical scrolling on how wide the container is so it feels more natural.
            end: "bottom",
          }
        });
      }
    }

    }






      if (document.querySelector('#matter') != null) {

        var text = gsap.timeline({
          scrollTrigger: {
            trigger: ".text__wrapper",
            start: "top",
            end: "bottom",
            scrub: true,
            pin: true,
           // markers: true,
            //    pinSpacing: false,
            //   markers: true,
            id: "scrub",

          }

        });

        text.from(".box", {
          duration: 0.5, opacity: 0,
          rotationZ: 90,
          x: -100,
          y: 200,
          scale: 0.25, stagger: 0.1
        });
      }






      if (document.querySelector('#matter') != null) {
        gsap.timeline({
          scrollTrigger: {
            trigger: ".logo__scroll",
            start: "0%",
            end: "100%",
            pin: true,
            scrub: true,
          //  markers: true,
          }
        })
            .from(".logo__scroll__headline", {opacity: 1});


        gsap.timeline({
          scrollTrigger: {
            trigger: ".swiper-quotes",
            start: "0%",
            end: "100%",
            pin: true,
            scrub: true,
         //   markers: true,
          }
        })
            .from(".swiper-quotes h1", {opacity: 1});
      }








  if (document.querySelector('#matter') != null) {




// C


    /*
      const path = document.querySelector('.path');

    var svg = Bodies.fromVertices(
        200,
        400,
        Vertices.scale(Svg.pathToVertices(path, 10),
            letterSizeHorizontal,
            letterSizeVertical), {
          render: {
            sprite: {
              texture: 'https://www.saschakrischock.com/dev/wordpress/cooltura/letters/logo.png',
              xScale: 1,
              yScale: 1
            }
          }
        });
*/






/*
    var logo = Bodies.rectangle(755, 300, 1550, 264, {
      chamfer: {radius: 20},
      render: {
        fillStyle: '#fff8f5',
      }
    });





    var circle_1 = Bodies.circle(400, 100, 100, {
      render: {
        sprite: {
          texture: 'https://www.saschakrischock.com/dev/wordpress/cooltura/letters/circle_1.png',
          xScale: 0.255,
          yScale: 0.255
        }
      }
    });

    var circle_2 = Bodies.circle(700, 100, 100, {
      render: {
        sprite: {
          texture: 'https://www.saschakrischock.com/dev/wordpress/cooltura/letters/circle_2.png',
          xScale: 0.255,
          yScale: 0.255
        }
      }
    })
    var circle_3 = Bodies.rectangle(1200, 100, 200, 200, {
      chamfer: {radius: 20},
      render: {
        sprite: {
          texture: 'https://www.saschakrischock.com/dev/wordpress/cooltura/letters/circle_3.png',
          xScale: 0.255,
          yScale: 0.255
        }
      }
    })



    var circle_1 = Bodies.circle(200, 100, 100, {
      render: {
        sprite: {
          texture: 'https://www.saschakrischock.com/dev/wordpress/cooltura/letters/circle_1.png',
          xScale: 0.255,
          yScale: 0.255
        }
      }
    });

    var circle_2 = Bodies.circle(600, 100, 100, {
      render: {
        sprite: {
          texture: 'https://www.saschakrischock.com/dev/wordpress/cooltura/letters/circle_2.png',
          xScale: 0.255,
          yScale: 0.255
        }
      }
    })
    var circle_3 = Bodies.rectangle(900, 100, 200, 200, {
      chamfer: {radius: 20},
      render: {
        sprite: {
          texture: 'https://www.saschakrischock.com/dev/wordpress/cooltura/letters/circle_3.png',
          xScale: 0.255,
          yScale: 0.255
        }
      }
    })
    */





/*
    const limitMaxSpeed = () => {
      let maxSpeed = 1;
      if (body.velocity.x > maxSpeed) {
        Body.setVelocity(body, { x: maxSpeed, y: body.velocity.y });
      }

      if (body.velocity.x < -maxSpeed) {
        Body.setVelocity(body, { x: -maxSpeed, y: body.velocity.y });
      }

      if (body.velocity.y > maxSpeed) {
        Body.setVelocity(body, { x: body.velocity.x, y: maxSpeed });
      }

      if (body.velocity.y < -maxSpeed) {
        Body.setVelocity(body, { x: -body.velocity.x, y: -maxSpeed });
      }
    }
    Matter.Events.on(engine, 'beforeUpdate', limitMaxSpeed);*/
// mouse control




  }











  all();

  barba.use(css);
  barba.init({
    preventRunning: true,
    timeout: 200000,
    transitions: [

      {

        beforeLeave: function (data) {

        },


        beforeEnter: function (data) {

          document.querySelector('.mobile__menu').classList.remove('active');
          document.querySelector('.header').classList.remove('black');
          document.body.classList.remove('black');
          document.querySelector('.menu__trigger').classList.remove('active');


          if (document.querySelector('video') != null) {
            let videos = document.querySelectorAll("video");

            videos.forEach(function (video, index) {
              video.pause();
              video.currentTime = 0;
              video.load();
            });
          }

        //  document.querySelector('.cursor__wrapper').classList.remove('active');
       //   document.querySelector('.cursor__pointer__drag').classList.remove('active');
       //   document.querySelector('.cursor__pointer').classList.remove('active');



        },
        afterEnter: function (data) {




          ScrollTrigger.refresh();




     setTimeout(function(){
            ScrollTrigger.refresh();
          }, 3000);


          setTimeout(function(){
          (function(e){var t={};function r(n){if(t[n])return t[n].exports;var a=t[n]={i:n,l:false,exports:{}};e[n].call(a.exports,a,a.exports,r);a.l=true;return a.exports}r.m=e;r.c=t;r.d=function(e,t,n){if(!r.o(e,t))Object.defineProperty(e,t,{enumerable:true,get:n})};r.r=function(e){if("undefined"!==typeof Symbol&&Symbol.toStringTag)Object.defineProperty(e,Symbol.toStringTag,{value:"Module"});Object.defineProperty(e,"__esModule",{value:true})};r.t=function(e,t){if(1&t)e=r(e);if(8&t)return e;if(4&t&&"object"===typeof e&&e&&e.__esModule)return e;var n=Object.create(null);r.r(n);Object.defineProperty(n,"default",{enumerable:true,value:e});if(2&t&&"string"!=typeof e)for(var a in e)r.d(n,a,function(t){return e[t]}.bind(null,a));return n};r.n=function(e){var t=e&&e.__esModule?function t(){return e["default"]}:function t(){return e};r.d(t,"a",t);return t};r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)};r.p="/";return r(r.s=0)})({0:function(e,t,r){r("3fe06cb9615786e0ea67");e.exports=r("3177845424933048caec")},"0116c75136b233002fb9":function(e,t){var r={}.toString;e.exports=function(e){return r.call(e).slice(8,-1)}},"03192b087bb464f059c0":function(e,t,r){"use strict";var n=r("d394d0a4c1838202489d");var a=r("23d432718b3e8ce32362");var c=r("ca19e32ab6ee3b3692aa");e.exports=function e(t){var r=n(this);var o=c(r.length);var i=arguments.length;var f=a(i>1?arguments[1]:void 0,o);var u=i>2?arguments[2]:void 0;var d=void 0===u?o:a(u,o);while(d>f)r[f++]=t;return r}},"0565be87d109f51269ca":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("ecd0e0fb36455021f082")(2);n(n.P+n.F*!r("40b064d4eb439c0c1c2b")([].filter,true),"Array",{filter:function e(t){return a(this,t,arguments[1])}})},"0594430ce9777a0767aa":function(e,t,r){var n=r("6ae9955278ddcf01bbfd");e.exports=function(e,t){return new(n(e))(t)}},"06b2b473e53cc019ca74":function(e,t,r){"use strict";var n=r("d394d0a4c1838202489d");var a=r("23d432718b3e8ce32362");var c=r("ca19e32ab6ee3b3692aa");e.exports=[].copyWithin||function e(t,r){var o=n(this);var i=c(o.length);var f=a(t,i);var u=a(r,i);var d=arguments.length>2?arguments[2]:void 0;var s=Math.min((void 0===d?i:a(d,i))-u,i-f);var v=1;if(u<f&&f<u+s){v=-1;u+=s-1;f+=s-1}while(s-- >0){if(u in o)o[f]=o[u];else delete o[f];f+=v;u+=v}return o}},"0a5193b0534d54dbcda1":function(e,t,r){"use strict";var n=r("0e717e1f47872428608d");var a=r("2d13d93c336705cd8ff9");var c=r("d394d0a4c1838202489d");var o=r("4357234160788ed77205");var i=r("71d3ec5bd65418e28ebc");var f=r("ca19e32ab6ee3b3692aa");var u=r("8de492c765fbfb624515");var d=r("f88518adc3004bf8d923");a(a.S+a.F*!r("574ea81f94fc0b2f332a")((function(e){Array.from(e)})),"Array",{from:function e(t){var r=c(t);var a="function"==typeof this?this:Array;var s=arguments.length;var v=s>1?arguments[1]:void 0;var l=void 0!==v;var b=0;var h=d(r);var p,y,m,g;if(l)v=n(v,s>2?arguments[2]:void 0,2);if(void 0!=h&&!(a==Array&&i(h)))for(g=h.call(r),y=new a;!(m=g.next()).done;b++)u(y,b,l?o(g,v,[m.value,b],true):m.value);else{p=f(r.length);for(y=new a(p);p>b;b++)u(y,b,l?v(r[b],b):r[b])}y.length=b;return y}})},"0e717e1f47872428608d":function(e,t,r){var n=r("4d073e2fededcdd3f3d3");e.exports=function(e,t,r){n(e);if(void 0===t)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,n){return e.call(t,r,n)};case 3:return function(r,n,a){return e.call(t,r,n,a)}}return function(){return e.apply(t,arguments)}}},"0f025c284bc567debf3d":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("ecd0e0fb36455021f082")(0);var c=r("40b064d4eb439c0c1c2b")([].forEach,true);n(n.P+n.F*!c,"Array",{forEach:function e(t){return a(this,t,arguments[1])}})},"1139de1233fd67f45bd7":function(e,t){var r=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();if("number"==typeof __g)__g=r},"12323e1413cbffdabe02":function(e,t,r){var n=r("d34390b928ecadc11dc8");var a=r("d394d0a4c1838202489d");var c=r("5f6eded14a8ed86276fc")("IE_PROTO");var o=Object.prototype;e.exports=Object.getPrototypeOf||function(e){e=a(e);if(n(e,c))return e[c];if("function"==typeof e.constructor&&e instanceof e.constructor)return e.constructor.prototype;return e instanceof Object?o:null}},"145c4f2bdc487b2578df":function(e,t,r){var n=r("e3136eea77d23f8d97ec");var a=r("380c0734c088ca78ccda");e.exports=Object.keys||function e(t){return n(t,a)}},"1468f5d37f30f63d76ea":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("efae14a3f8cd9a616256");var c=r("1f3157d073736826d4fa");var o=r("ca19e32ab6ee3b3692aa");var i=[].lastIndexOf;var f=!!i&&1/[1].lastIndexOf(1,-0)<0;n(n.P+n.F*(f||!r("40b064d4eb439c0c1c2b")(i)),"Array",{lastIndexOf:function e(t){if(f)return i.apply(this,arguments)||0;var r=a(this);var n=o(r.length);var u=n-1;if(arguments.length>1)u=Math.min(u,c(arguments[1]));if(u<0)u=n+u;for(;u>=0;u--)if(u in r)if(r[u]===t)return u||0;return-1}})},"1591b90b4327c94245ad":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("ecd0e0fb36455021f082")(1);n(n.P+n.F*!r("40b064d4eb439c0c1c2b")([].map,true),"Array",{map:function e(t){return a(this,t,arguments[1])}})},"1b01d0e59d3af79760a0":function(e,t,r){var n=r("79c91dcd8cd554c59c7b");var a=r("bc1a333d2b6eceac22e3");var c=r("4ef7a75a1d1957a7c5c0");var o=Object.defineProperty;t.f=r("5975c7ea3ecd56e534e3")?Object.defineProperty:function e(t,r,i){n(t);r=c(r,true);n(i);if(a)try{return o(t,r,i)}catch(f){}if("get"in i||"set"in i)throw TypeError("Accessors not supported!");if("value"in i)t[r]=i.value;return t}},"1b24b031f63a74d1f57f":function(e,t,r){"use strict";var n=r("f8f08bdd917755ac017a");function a(){}var c=null;var o={};function i(e){try{return e.then}catch(t){c=t;return o}}function f(e,t){try{return e(t)}catch(r){c=r;return o}}function u(e,t,r){try{e(t,r)}catch(n){c=n;return o}}e.exports=d;function d(e){if("object"!==typeof this)throw new TypeError("Promises must be constructed via new");if("function"!==typeof e)throw new TypeError("Promise constructor's argument is not a function");this._U=0;this._V=0;this._W=null;this._X=null;if(e===a)return;m(e,this)}d._Y=null;d._Z=null;d._0=a;d.prototype.then=function(e,t){if(this.constructor!==d)return s(this,e,t);var r=new d(a);v(this,new y(e,t,r));return r};function s(e,t,r){return new e.constructor((function(n,c){var o=new d(a);o.then(n,c);v(e,new y(t,r,o))}))}function v(e,t){while(3===e._V)e=e._W;if(d._Y)d._Y(e);if(0===e._V){if(0===e._U){e._U=1;e._X=t;return}if(1===e._U){e._U=2;e._X=[e._X,t];return}e._X.push(t);return}l(e,t)}function l(e,t){n((function(){var r=1===e._V?t.onFulfilled:t.onRejected;if(null===r){if(1===e._V)b(t.promise,e._W);else h(t.promise,e._W);return}var n=f(r,e._W);if(n===o)h(t.promise,c);else b(t.promise,n)}))}function b(e,t){if(t===e)return h(e,new TypeError("A promise cannot be resolved with itself."));if(t&&("object"===typeof t||"function"===typeof t)){var r=i(t);if(r===o)return h(e,c);if(r===e.then&&t instanceof d){e._V=3;e._W=t;p(e);return}else if("function"===typeof r){m(r.bind(t),e);return}}e._V=1;e._W=t;p(e)}function h(e,t){e._V=2;e._W=t;if(d._Z)d._Z(e,t);p(e)}function p(e){if(1===e._U){v(e,e._X);e._X=null}if(2===e._U){for(var t=0;t<e._X.length;t++)v(e,e._X[t]);e._X=null}}function y(e,t,r){this.onFulfilled="function"===typeof e?e:null;this.onRejected="function"===typeof t?t:null;this.promise=r}function m(e,t){var r=false;var n=u(e,(function(e){if(r)return;r=true;b(t,e)}),(function(e){if(r)return;r=true;h(t,e)}));if(!r&&n===o){r=true;h(t,c)}}},"1b71f5e96f29a92413b6":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("5b9dc0e027f5c68eff1a");var c=r("0116c75136b233002fb9");var o=r("23d432718b3e8ce32362");var i=r("ca19e32ab6ee3b3692aa");var f=[].slice;n(n.P+n.F*r("7a7739dd8a198a2cfcb5")((function(){if(a)f.call(a)})),"Array",{slice:function e(t,r){var n=i(this.length);var a=c(this);r=void 0===r?n:r;if("Array"==a)return f.call(this,t,r);var u=o(t,n);var d=o(r,n);var s=i(d-u);var v=new Array(s);var l=0;for(;l<s;l++)v[l]="String"==a?this.charAt(u+l):this[u+l];return v}})},"1e0f00d296712713afe6":function(e,t,r){var n=r("4d073e2fededcdd3f3d3");var a=r("d394d0a4c1838202489d");var c=r("a537d0accb907bf9d41f");var o=r("ca19e32ab6ee3b3692aa");e.exports=function(e,t,r,i,f){n(t);var u=a(e);var d=c(u);var s=o(u.length);var v=f?s-1:0;var l=f?-1:1;if(r<2)for(;;){if(v in d){i=d[v];v+=l;break}v+=l;if(f?v<0:s<=v)throw TypeError("Reduce of empty array with no initial value")}for(;f?v>=0:s>v;v+=l)if(v in d)i=t(i,d[v],v,u);return i}},"1f3157d073736826d4fa":function(e,t){var r=Math.ceil;var n=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?n:r)(e)}},"2076e982c14c41925fb4":function(e,t,r){var n=r("efae14a3f8cd9a616256");var a=r("ca19e32ab6ee3b3692aa");var c=r("23d432718b3e8ce32362");e.exports=function(e){return function(t,r,o){var i=n(t);var f=a(i.length);var u=c(o,f);var d;if(e&&r!=r)while(f>u){d=i[u++];if(d!=d)return true}else for(;f>u;u++)if(e||u in i)if(i[u]===r)return e||u||0;return!e&&-1}}},"224ae09e536c09e69a0a":function(e,t){e.exports={}},"23617503340803072f22":function(e,t,r){"use strict";r.d(t,"b",(function(){return o}));r.d(t,"d",(function(){return i}));r.d(t,"a",(function(){return v}));r.d(t,"c",(function(){return l}));function n(e,t,r,n,a,c,o){try{var i=e[c](o);var f=i.value}catch(u){r(u);return}if(i.done)t(f);else Promise.resolve(f).then(n,a)}function a(e){return function(){var t=this,r=arguments;return new Promise((function(a,c){var o=e.apply(t,r);function i(e){n(o,a,c,i,f,"next",e)}function f(e){n(o,a,c,i,f,"throw",e)}i(void 0)}))}}function c(e){"@babel/helpers - typeof";return c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c(e)}function o(){return Math.round(1e17*Math.random())}function i(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];var t=arguments.length>1?arguments[1]:void 0;var r=arguments.length>2?arguments[2]:void 0;if(!e.length||!t)return[];return e.reduce((function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];var n=arguments.length>1?arguments[1]:void 0;var a=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0;var c=Math.floor(a/t);if(!e[c])e[c]=[];if(r)e[c].push(n[r]);else e[c].push(n);return e}),[])}function f(e,t){var r=t.type||"GET";var n=t.data;var a=t.success,o=void 0===a?function e(t,r){void 0}:a,i=t.fail,f=void 0===i?function e(t,r){void 0}:i;var u=new XMLHttpRequest;u.onreadystatechange=function(){if(4===Number(u.readyState))if(u.status>=200&&u.status<300||304===u.status)o(u.responseText,u);else f(u.responseText,u)};function d(e){var t=e;var r=[];if("string"===typeof t)t=encodeURI(t);else if("object"===c(t)){Object.keys(t).forEach((function(e){r.push("".concat(e,"=").concat(encodeURIComponent(t[e].toString())))}));t=r.join("&")}return t}if("GET"===r.toUpperCase()){var s="".concat(e,"?").concat(d(n||""));u.open("get",s,true);u.send(null)}else if("POST"===r.toUpperCase()){u.open("post",e,true);u.setRequestHeader("Content-Type","application/x-www-form-urlencoded");u.send(d(n||""))}}function u(e,t){return d.apply(this,arguments)}function d(){d=a(regeneratorRuntime.mark((function e(t,r){return regeneratorRuntime.wrap((function e(n){while(1)switch(n.prev=n.next){case 0:return n.abrupt("return",new Promise((function(e,n){var a={data:r,success:e,fail:n};f(t,a)})).then((function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"{}";var t={};try{t=JSON.parse(e)}catch(r){t={}}return t})));case 1:case"end":return n.stop()}}),e)})));return d.apply(this,arguments)}function s(){var e="TikTok";var t={};var r=function t(r){return"[".concat(e,"] ").concat(r.toString())};["error","log","info"].forEach((function(e){t[e]=function(t){if("info"===e)void 0;else void 0}}));return t}var v=s();function l(e){var t=e.replace(/[\[]/,"\\[").replace(/[\]]/,"\\]");var r=new RegExp("[\\?&]".concat(t,"=([^&#]*)"));var n=r.exec(location.search);return null===n?"":decodeURIComponent(n[1].replace(/\+/g," "))}function b(){return false||"production"==="dev"}},"23d432718b3e8ce32362":function(e,t,r){var n=r("1f3157d073736826d4fa");var a=Math.max;var c=Math.min;e.exports=function(e,t){e=n(e);return e<0?a(e+t,0):c(e,t)}},"273d2eedcd369c189e70":function(e,t){var r=0;var n=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++r+n).toString(36))}},"2c09af3fb5c4ba3698b3":function(e,t,r){var n=function(e){"use strict";var t=Object.prototype;var r=t.hasOwnProperty;var n;var a="function"===typeof Symbol?Symbol:{};var c=a.iterator||"@@iterator";var o=a.asyncIterator||"@@asyncIterator";var i=a.toStringTag||"@@toStringTag";function f(e,t,r,n){var a=t&&t.prototype instanceof h?t:h;var c=Object.create(a.prototype);var o=new O(n||[]);c._invoke=j(e,r,o);return c}e.wrap=f;function u(e,t,r){try{return{type:"normal",arg:e.call(t,r)}}catch(n){return{type:"throw",arg:n}}}var d="suspendedStart";var s="suspendedYield";var v="executing";var l="completed";var b={};function h(){}function p(){}function y(){}var m={};m[c]=function(){return this};var g=Object.getPrototypeOf;var w=g&&g(g(P([])));if(w&&w!==t&&r.call(w,c))m=w;var x=y.prototype=h.prototype=Object.create(m);p.prototype=x.constructor=y;y.constructor=p;y[i]=p.displayName="GeneratorFunction";function _(e){["next","throw","return"].forEach((function(t){e[t]=function(e){return this._invoke(t,e)}}))}e.isGeneratorFunction=function(e){var t="function"===typeof e&&e.constructor;return t?t===p||"GeneratorFunction"===(t.displayName||t.name):false};e.mark=function(e){if(Object.setPrototypeOf)Object.setPrototypeOf(e,y);else{e.__proto__=y;if(!(i in e))e[i]="GeneratorFunction"}e.prototype=Object.create(x);return e};e.awrap=function(e){return{__await:e}};function k(e,t){function n(a,c,o,i){var f=u(e[a],e,c);if("throw"===f.type)i(f.arg);else{var d=f.arg;var s=d.value;if(s&&"object"===typeof s&&r.call(s,"__await"))return t.resolve(s.__await).then((function(e){n("next",e,o,i)}),(function(e){n("throw",e,o,i)}));return t.resolve(s).then((function(e){d.value=e;o(d)}),(function(e){return n("throw",e,o,i)}))}}var a;function c(e,r){function c(){return new t((function(t,a){n(e,r,t,a)}))}return a=a?a.then(c,c):c()}this._invoke=c}_(k.prototype);k.prototype[o]=function(){return this};e.AsyncIterator=k;e.async=function(t,r,n,a,c){if(void 0===c)c=Promise;var o=new k(f(t,r,n,a),c);return e.isGeneratorFunction(r)?o:o.next().then((function(e){return e.done?e.value:o.next()}))};function j(e,t,r){var n=d;return function a(c,o){if(n===v)throw new Error("Generator is already running");if(n===l){if("throw"===c)throw o;return T()}r.method=c;r.arg=o;while(true){var i=r.delegate;if(i){var f=A(i,r);if(f){if(f===b)continue;return f}}if("next"===r.method)r.sent=r._sent=r.arg;else if("throw"===r.method){if(n===d){n=l;throw r.arg}r.dispatchException(r.arg)}else if("return"===r.method)r.abrupt("return",r.arg);n=v;var h=u(e,t,r);if("normal"===h.type){n=r.done?l:s;if(h.arg===b)continue;return{value:h.arg,done:r.done}}else if("throw"===h.type){n=l;r.method="throw";r.arg=h.arg}}}}function A(e,t){var r=e.iterator[t.method];if(r===n){t.delegate=null;if("throw"===t.method){if(e.iterator["return"]){t.method="return";t.arg=n;A(e,t);if("throw"===t.method)return b}t.method="throw";t.arg=new TypeError("The iterator does not provide a 'throw' method")}return b}var a=u(r,e.iterator,t.arg);if("throw"===a.type){t.method="throw";t.arg=a.arg;t.delegate=null;return b}var c=a.arg;if(!c){t.method="throw";t.arg=new TypeError("iterator result is not an object");t.delegate=null;return b}if(c.done){t[e.resultName]=c.value;t.next=e.nextLoc;if("return"!==t.method){t.method="next";t.arg=n}}else return c;t.delegate=null;return b}_(x);x[i]="Generator";x[c]=function(){return this};x.toString=function(){return"[object Generator]"};function E(e){var t={tryLoc:e[0]};if(1 in e)t.catchLoc=e[1];if(2 in e){t.finallyLoc=e[2];t.afterLoc=e[3]}this.tryEntries.push(t)}function S(e){var t=e.completion||{};t.type="normal";delete t.arg;e.completion=t}function O(e){this.tryEntries=[{tryLoc:"root"}];e.forEach(E,this);this.reset(true)}e.keys=function(e){var t=[];for(var r in e)t.push(r);t.reverse();return function r(){while(t.length){var n=t.pop();if(n in e){r.value=n;r.done=false;return r}}r.done=true;return r}};function P(e){if(e){var t=e[c];if(t)return t.call(e);if("function"===typeof e.next)return e;if(!isNaN(e.length)){var a=-1,o=function t(){while(++a<e.length)if(r.call(e,a)){t.value=e[a];t.done=false;return t}t.value=n;t.done=true;return t};return o.next=o}}return{next:T}}e.values=P;function T(){return{value:n,done:true}}O.prototype={constructor:O,reset:function(e){this.prev=0;this.next=0;this.sent=this._sent=n;this.done=false;this.delegate=null;this.method="next";this.arg=n;this.tryEntries.forEach(S);if(!e)for(var t in this)if("t"===t.charAt(0)&&r.call(this,t)&&!isNaN(+t.slice(1)))this[t]=n},stop:function(){this.done=true;var e=this.tryEntries[0];var t=e.completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){if(this.done)throw e;var t=this;function a(r,a){i.type="throw";i.arg=e;t.next=r;if(a){t.method="next";t.arg=n}return!!a}for(var c=this.tryEntries.length-1;c>=0;--c){var o=this.tryEntries[c];var i=o.completion;if("root"===o.tryLoc)return a("end");if(o.tryLoc<=this.prev){var f=r.call(o,"catchLoc");var u=r.call(o,"finallyLoc");if(f&&u){if(this.prev<o.catchLoc)return a(o.catchLoc,true);else if(this.prev<o.finallyLoc)return a(o.finallyLoc)}else if(f){if(this.prev<o.catchLoc)return a(o.catchLoc,true)}else if(u){if(this.prev<o.finallyLoc)return a(o.finallyLoc)}else throw new Error("try statement without catch or finally")}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var a=this.tryEntries[n];if(a.tryLoc<=this.prev&&r.call(a,"finallyLoc")&&this.prev<a.finallyLoc){var c=a;break}}if(c&&("break"===e||"continue"===e)&&c.tryLoc<=t&&t<=c.finallyLoc)c=null;var o=c?c.completion:{};o.type=e;o.arg=t;if(c){this.method="next";this.next=c.finallyLoc;return b}return this.complete(o)},complete:function(e,t){if("throw"===e.type)throw e.arg;if("break"===e.type||"continue"===e.type)this.next=e.arg;else if("return"===e.type){this.rval=this.arg=e.arg;this.method="return";this.next="end"}else if("normal"===e.type&&t)this.next=t;return b},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.finallyLoc===e){this.complete(r.completion,r.afterLoc);S(r);return b}}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var r=this.tryEntries[t];if(r.tryLoc===e){var n=r.completion;if("throw"===n.type){var a=n.arg;S(r)}return a}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,r){this.delegate={iterator:P(e),resultName:t,nextLoc:r};if("next"===this.method)this.arg=n;return b}};return e}(true?e.exports:void 0);try{regeneratorRuntime=n}catch(a){Function("r","regeneratorRuntime = r")(n)}},"2d13d93c336705cd8ff9":function(e,t,r){var n=r("1139de1233fd67f45bd7");var a=r("5925dad3c5243ffee3db");var c=r("5f25c015bbbf9d42c661");var o=r("88db22626e6c88b175cf");var i=r("0e717e1f47872428608d");var f="prototype";var u=function(e,t,r){var d=e&u.F;var s=e&u.G;var v=e&u.S;var l=e&u.P;var b=e&u.B;var h=s?n:v?n[t]||(n[t]={}):(n[t]||{})[f];var p=s?a:a[t]||(a[t]={});var y=p[f]||(p[f]={});var m,g,w,x;if(s)r=t;for(m in r){g=!d&&h&&void 0!==h[m];w=(g?h:r)[m];x=b&&g?i(w,n):l&&"function"==typeof w?i(Function.call,w):w;if(h)o(h,m,w,e&u.U);if(p[m]!=w)c(p,m,x);if(l&&y[m]!=w)y[m]=w}};n.core=a;u.F=1;u.G=2;u.S=4;u.P=8;u.B=16;u.W=32;u.U=64;u.R=128;e.exports=u},"307014e72ed12da69e15":function(e,t,r){"use strict";var n=r("a5e6f0092ff0290e0bcf");var a=r("dabaabbe8ba08d59975f");var c=r("224ae09e536c09e69a0a");var o=r("efae14a3f8cd9a616256");e.exports=r("429cfc8e3ed333e40618")(Array,"Array",(function(e,t){this._t=o(e);this._i=0;this._k=t}),(function(){var e=this._t;var t=this._k;var r=this._i++;if(!e||r>=e.length){this._t=void 0;return a(1)}if("keys"==t)return a(0,r);if("values"==t)return a(0,e[r]);return a(0,[r,e[r]])}),"values");c.Arguments=c.Array;n("keys");n("values");n("entries")},"3177845424933048caec":function(e,t,r){"use strict";r.r(t);var n=r("3fe06cb9615786e0ea67");var a=r("e0b8897ffbf48a102fbb");var c,o;try{c=window.localStorage;o=window.sessionStorage}catch(p){}function i(e){function t(){if(!o)return false;var e="".concat(a["k"],"storage_test");var t="";try{t=o.getItem(e);if(!t)o.setItem(e,true)}catch(r){o.setItem(e,"")}return Boolean(t)}this.getItem=function(r){var n="";if(t())n=e.getItem("".concat(a["k"]).concat(r));return n};this.setItem=function(r,n){if(t())e.setItem("".concat(a["k"]).concat(r),n)};this.removeItem=function(r){if(t())e.removeItem("".concat(a["k"]).concat(r))}}var f=new i(c);var u=new i(o);var d=r("23617503340803072f22");function s(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function v(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function l(e,t,r){if(t)v(e.prototype,t);if(r)v(e,r);Object.defineProperty(e,"prototype",{writable:false});return e}function b(e,t,r,n,a,c,o){try{var i=e[c](o);var f=i.value}catch(u){r(u);return}if(i.done)t(f);else Promise.resolve(f).then(n,a)}function h(e){return function(){var t=this,r=arguments;return new Promise((function(n,a){var c=e.apply(t,r);function o(e){b(c,n,a,o,i,"next",e)}function i(e){b(c,n,a,o,i,"throw",e)}o(void 0)}))}}(function(){var e=h(regeneratorRuntime.mark((function e(t){var r,n,c,o;return regeneratorRuntime.wrap((function e(i){while(1)switch(i.prev=i.next){case 0:r=t;n="true";c=function(){function e(){s(this,e);this.mountStatus=false}l(e,[{key:"mount",value:function(){var e=h(regeneratorRuntime.mark((function e(){var t,r;return regeneratorRuntime.wrap((function e(a){while(1)switch(a.prev=a.next){case 0:t=this.mountStatus===n;if(!t){a.next=5;break}this.setNewMount(true);a.next=14;break;case 5:this.mountStatus=true;a.next=8;return this.checkLib();case 8:r=a.sent;if(!r){a.next=14;break}a.next=12;return this.libHandle();case 12:this.checkNewMount();this.mountStatus=false;case 14:case"end":return a.stop()}}),e,this)})));return function t(){return e.apply(this,arguments)}}()},{key:"checkLib",value:function(){var e=h(regeneratorRuntime.mark((function e(){var t,n;return regeneratorRuntime.wrap((function e(c){while(1)switch(c.prev=c.next){case 0:t=false;if(!r[a["j"]])r[a["j"]]={};n=r[a["j"]].version;if(!n){n=this.getLibVersion();r[a["j"]].version=n}c.prev=4;c.next=7;return Promise.all([this.checkCSS(n),this.checkScript(n)]);case 7:t=c.sent;c.next=14;break;case 10:c.prev=10;c.t0=c["catch"](4);t=false;d["a"].error(c.t0);case 14:return c.abrupt("return",t);case 15:case"end":return c.stop()}}),e,this,[[4,10]])})));return function t(){return e.apply(this,arguments)}}()},{key:"libHandle",value:function(){var e=h(regeneratorRuntime.mark((function e(){var t,n,c,o,i;return regeneratorRuntime.wrap((function e(f){while(1)switch(f.prev=f.next){case 0:t=r[a["j"]]||{},n=t.lib,c=t.isEventsInit,o=void 0===c?false:c;if(o){f.next=6;break}f.t0=n;if(!f.t0){f.next=6;break}f.next=6;return n.init();case 6:i=this.collectNodes();f.t1=n;if(!f.t1){f.next=11;break}f.next=11;return n.render(i);case 11:case"end":return f.stop()}}),e,this)})));return function t(){return e.apply(this,arguments)}}()},{key:"collectNodes",value:function e(){var t=document.getElementsByClassName(a["i"]);var r=[];if(t.length)r=Array.prototype.filter.call(t,(function(e){var t=e.nodeName.toLowerCase()===a["l"];var r=!e.id;return t&&r}));return r}},{key:"getLibVersion",value:function e(){return a["e"]}},{key:"checkCSS",value:function e(t){return new Promise((function(e){var r=document.getElementById(a["c"]);if(r)e(true);else{var n=document.createElement("link");n.rel="stylesheet";n.type="text/css";n.id=a["c"];n.href="".concat(a["b"],"/").concat(a["f"]).concat(t,".css");document.head.appendChild(n);n.onload=function(){e(true)};n.onerror=function(t){d["a"].error(t);e(false)}}}))}},{key:"checkScript",value:function e(t){return new Promise((function(e){var r=document.getElementById(a["d"]);if(r)e(true);else{var n=document.createElement("script");n.type="text/javascript";n.id=a["d"];n.src="".concat(a["b"],"/").concat(a["f"]).concat(t,".js");document.body.appendChild(n);n.onload=function(){e(true)};n.onerror=function(t){d["a"].error(t);e(false)}}}))}},{key:"checkNewMount",value:function e(){var t=u.getItem(a["h"])||"";var r=t===n;if(r){this.mount();this.setNewMount(false)}}},{key:"setNewMount",value:function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";u.setItem(a["h"],t)}},{key:"mountStatus",set:function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"";u.setItem(a["g"],t)},get:function e(){return u.getItem(a["g"])||""}}]);return e}();o=function(){var e=h(regeneratorRuntime.mark((function e(){var t;return regeneratorRuntime.wrap((function e(r){while(1)switch(r.prev=r.next){case 0:t=new c;r.next=3;return t.mount();case 3:case"end":return r.stop()}}),e)})));return function t(){return e.apply(this,arguments)}}();setTimeout(o,0);case 5:case"end":return i.stop()}}),e)})));return function t(r){return e.apply(this,arguments)}})()(window)},"32b716d95af2fd3c5c23":function(e,t,r){var n=r("0116c75136b233002fb9");var a=r("621a65702ee1a566fd32")("toStringTag");var c="Arguments"==n(function(){return arguments}());var o=function(e,t){try{return e[t]}catch(r){}};e.exports=function(e){var t,r,i;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(r=o(t=Object(e),a))?r:c?n(t):"Object"==(i=n(t))&&"function"==typeof t.callee?"Arguments":i}},"340dbda6fe6f17098a91":function(e,t,r){"use strict";var n=r("770f76c876afc046e4e0")(true);r("429cfc8e3ed333e40618")(String,"String",(function(e){this._t=String(e);this._i=0}),(function(){var e=this._t;var t=this._i;var r;if(t>=e.length)return{value:void 0,done:true};r=n(e,t);this._i+=r.length;return{value:r,done:false}}))},"380c0734c088ca78ccda":function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},"3932316ffef991f5d157":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("ecd0e0fb36455021f082")(5);var c="find";var o=true;if(c in[])Array(1)[c]((function(){o=false}));n(n.P+n.F*o,"Array",{find:function e(t){return a(this,t,arguments.length>1?arguments[1]:void 0)}});r("a5e6f0092ff0290e0bcf")(c)},"3f2012daa60f226e86ec":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("8de492c765fbfb624515");n(n.S+n.F*r("7a7739dd8a198a2cfcb5")((function(){function e(){}return!(Array.of.call(e)instanceof e)})),"Array",{of:function e(){var t=0;var r=arguments.length;var n=new("function"==typeof this?this:Array)(r);while(r>t)a(n,t,arguments[t++]);n.length=r;return n}})},"3fc8b4ca32b0aebd9ff3":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("ecd0e0fb36455021f082")(6);var c="findIndex";var o=true;if(c in[])Array(1)[c]((function(){o=false}));n(n.P+n.F*o,"Array",{findIndex:function e(t){return a(this,t,arguments.length>1?arguments[1]:void 0)}});r("a5e6f0092ff0290e0bcf")(c)},"3fe06cb9615786e0ea67":function(e,t,r){window.regeneratorRuntime=r("2c09af3fb5c4ba3698b3");r("a6444c69152f1487917b");if("undefined"===typeof Promise){r("9fbadcf2c98d054f245e").enable();window.Promise=r("e6615fafe8e11b81e37a")}},"40b064d4eb439c0c1c2b":function(e,t,r){"use strict";var n=r("7a7739dd8a198a2cfcb5");e.exports=function(e,t){return!!e&&n((function(){t?e.call(null,(function(){}),1):e.call(null)}))}},"40b8419e3e2132ef0a63":function(e){e.exports={name:"tiktok_embed",version:"1.0.11",embedVersion:"1.0.11",description:"TikTok Embed SDK",main:"index.js",scripts:{test:"jest --forceExit",dev:"eden start",build:"eden build","build:gcp":"NODE_REGION=GCP eden build","build:dev":"eden build -a",commit:"eden push",feature:"eden feature",mr:"eden release -m",lint:"eden-lint ./src --fix"},keywords:["tiktok","embed"],author:"yangminghui.jasmine, chloe.chao",license:"ISC",devDependencies:{"@ies/create-eden-config":"^1.0.2","@ies/eden-lint":"^2.15.4","@testing-library/dom":"^8.17.1","@testing-library/jest-dom":"^5.16.5",jest:"^28.1.3",jsdom:"^20.0.0"},dependencies:{"core-js":"2.5.7",promise:"^8.0.3","regenerator-runtime":"^0.13.3"},husky:{hooks:{"commit-msg":"commitlint .commitlintrc.js -E HUSKY_GIT_PARAMS","pre-commit":"lint-staged"}},"lint-staged":{"*":["eden lint format","git add"]}}},"429cfc8e3ed333e40618":function(e,t,r){"use strict";var n=r("46a1a30d151cac60057c");var a=r("2d13d93c336705cd8ff9");var c=r("88db22626e6c88b175cf");var o=r("5f25c015bbbf9d42c661");var i=r("224ae09e536c09e69a0a");var f=r("5c5d334c57135891e397");var u=r("62828dc3ffa96c06b7c9");var d=r("12323e1413cbffdabe02");var s=r("621a65702ee1a566fd32")("iterator");var v=!([].keys&&"next"in[].keys());var l="@@iterator";var b="keys";var h="values";var p=function(){return this};e.exports=function(e,t,r,y,m,g,w){f(r,t,y);var x=function(e){if(!v&&e in A)return A[e];switch(e){case b:return function t(){return new r(this,e)};case h:return function t(){return new r(this,e)}}return function t(){return new r(this,e)}};var _=t+" Iterator";var k=m==h;var j=false;var A=e.prototype;var E=A[s]||A[l]||m&&A[m];var S=E||x(m);var O=m?!k?S:x("entries"):void 0;var P="Array"==t?A.entries||E:E;var T,I,R;if(P){R=d(P.call(new e));if(R!==Object.prototype&&R.next){u(R,_,true);if(!n&&"function"!=typeof R[s])o(R,s,p)}}if(k&&E&&E.name!==h){j=true;S=function e(){return E.call(this)}}if((!n||w)&&(v||j||!A[s]))o(A,s,S);i[t]=S;i[_]=p;if(m){T={values:k?S:x(h),keys:g?S:x(b),entries:O};if(w){for(I in T)if(!(I in A))c(A,I,T[I])}else a(a.P+a.F*(v||j),t,T)}return T}},"43382cd620aa5a0df057":function(e,t){var r;r=function(){return this}();try{r=r||Function("return this")()||(1,eval)("this")}catch(n){if("object"===typeof window)r=window}e.exports=r},"4357234160788ed77205":function(e,t,r){var n=r("79c91dcd8cd554c59c7b");e.exports=function(e,t,r,a){try{return a?t(n(r)[0],r[1]):t(r)}catch(o){var c=e["return"];if(void 0!==c)n(c.call(e));throw o}}},"43a62b7f9a94dda95bf8":function(e,t,r){var n=r("5925dad3c5243ffee3db");var a=r("1139de1233fd67f45bd7");var c="__core-js_shared__";var o=a[c]||(a[c]={});(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:n.version,mode:r("46a1a30d151cac60057c")?"pure":"global",copyright:"\xa9 2018 Denis Pushkarev (zloirock.ru)"})},"46a1a30d151cac60057c":function(e,t){e.exports=false},"481c1f0e850b0c8d0f7d":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("1e0f00d296712713afe6");n(n.P+n.F*!r("40b064d4eb439c0c1c2b")([].reduce,true),"Array",{reduce:function e(t){return a(this,t,arguments.length,arguments[1],false)}})},"4cc77e026250beeef142":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("efae14a3f8cd9a616256");var c=[].join;n(n.P+n.F*(r("a537d0accb907bf9d41f")!=Object||!r("40b064d4eb439c0c1c2b")(c)),"Array",{join:function e(t){return c.call(a(this),void 0===t?",":t)}})},"4d073e2fededcdd3f3d3":function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},"4ef7a75a1d1957a7c5c0":function(e,t,r){var n=r("a459ab805827640a27e8");e.exports=function(e,t){if(!n(e))return e;var r,a;if(t&&"function"==typeof(r=e.toString)&&!n(a=r.call(e)))return a;if("function"==typeof(r=e.valueOf)&&!n(a=r.call(e)))return a;if(!t&&"function"==typeof(r=e.toString)&&!n(a=r.call(e)))return a;throw TypeError("Can't convert object to primitive value")}},"574ea81f94fc0b2f332a":function(e,t,r){var n=r("621a65702ee1a566fd32")("iterator");var a=false;try{var c=[7][n]();c["return"]=function(){a=true};Array.from(c,(function(){throw 2}))}catch(o){}e.exports=function(e,t){if(!t&&!a)return false;var r=false;try{var c=[7];var i=c[n]();i.next=function(){return{done:r=true}};c[n]=function(){return i};e(c)}catch(o){}return r}},"5925dad3c5243ffee3db":function(e,t){var r=e.exports={version:"2.5.7"};if("number"==typeof __e)__e=r},"5975c7ea3ecd56e534e3":function(e,t,r){e.exports=!r("7a7739dd8a198a2cfcb5")((function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}))},"5b9dc0e027f5c68eff1a":function(e,t,r){var n=r("1139de1233fd67f45bd7").document;e.exports=n&&n.documentElement},"5baa1143f58e62614ca0":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("4d073e2fededcdd3f3d3");var c=r("d394d0a4c1838202489d");var o=r("7a7739dd8a198a2cfcb5");var i=[].sort;var f=[1,2,3];n(n.P+n.F*(o((function(){f.sort(void 0)}))||!o((function(){f.sort(null)}))||!r("40b064d4eb439c0c1c2b")(i)),"Array",{sort:function e(t){return void 0===t?i.call(c(this)):i.call(c(this),a(t))}})},"5c5d334c57135891e397":function(e,t,r){"use strict";var n=r("ef09ce044ac3210bc947");var a=r("9d5592e83ab7f3d08974");var c=r("62828dc3ffa96c06b7c9");var o={};r("5f25c015bbbf9d42c661")(o,r("621a65702ee1a566fd32")("iterator"),(function(){return this}));e.exports=function(e,t,r){e.prototype=n(o,{next:a(1,r)});c(e,t+" Iterator")}},"5f25c015bbbf9d42c661":function(e,t,r){var n=r("1b01d0e59d3af79760a0");var a=r("9d5592e83ab7f3d08974");e.exports=r("5975c7ea3ecd56e534e3")?function(e,t,r){return n.f(e,t,a(1,r))}:function(e,t,r){e[t]=r;return e}},"5f6eded14a8ed86276fc":function(e,t,r){var n=r("43a62b7f9a94dda95bf8")("keys");var a=r("273d2eedcd369c189e70");e.exports=function(e){return n[e]||(n[e]=a(e))}},"621a65702ee1a566fd32":function(e,t,r){var n=r("43a62b7f9a94dda95bf8")("wks");var a=r("273d2eedcd369c189e70");var c=r("1139de1233fd67f45bd7").Symbol;var o="function"==typeof c;var i=e.exports=function(e){return n[e]||(n[e]=o&&c[e]||(o?c:a)("Symbol."+e))};i.store=n},"62828dc3ffa96c06b7c9":function(e,t,r){var n=r("1b01d0e59d3af79760a0").f;var a=r("d34390b928ecadc11dc8");var c=r("621a65702ee1a566fd32")("toStringTag");e.exports=function(e,t,r){if(e&&!a(e=r?e:e.prototype,c))n(e,c,{configurable:true,value:t})}},"68a989d6f90923909f2a":function(e,t,r){var n=r("a459ab805827640a27e8");var a=r("1139de1233fd67f45bd7").document;var c=n(a)&&n(a.createElement);e.exports=function(e){return c?a.createElement(e):{}}},"6ae9955278ddcf01bbfd":function(e,t,r){var n=r("a459ab805827640a27e8");var a=r("8f648b1026e01323935b");var c=r("621a65702ee1a566fd32")("species");e.exports=function(e){var t;if(a(e)){t=e.constructor;if("function"==typeof t&&(t===Array||a(t.prototype)))t=void 0;if(n(t)){t=t[c];if(null===t)t=void 0}}return void 0===t?Array:t}},"71d3ec5bd65418e28ebc":function(e,t,r){var n=r("224ae09e536c09e69a0a");var a=r("621a65702ee1a566fd32")("iterator");var c=Array.prototype;e.exports=function(e){return void 0!==e&&(n.Array===e||c[a]===e)}},"74be682203e7c82cb4c9":function(e,t,r){r("89a21af31babcdc56725")("Array")},"770f76c876afc046e4e0":function(e,t,r){var n=r("1f3157d073736826d4fa");var a=r("7ad2c0eb9a8edcc472a4");e.exports=function(e){return function(t,r){var c=String(a(t));var o=n(r);var i=c.length;var f,u;if(o<0||o>=i)return e?"":void 0;f=c.charCodeAt(o);return f<55296||f>56319||o+1===i||(u=c.charCodeAt(o+1))<56320||u>57343?e?c.charAt(o):f:e?c.slice(o,o+2):(f-55296<<10)+(u-56320)+65536}}},"79c91dcd8cd554c59c7b":function(e,t,r){var n=r("a459ab805827640a27e8");e.exports=function(e){if(!n(e))throw TypeError(e+" is not an object!");return e}},"7a7739dd8a198a2cfcb5":function(e,t){e.exports=function(e){try{return!!e()}catch(t){return true}}},"7ad2c0eb9a8edcc472a4":function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},"88db22626e6c88b175cf":function(e,t,r){var n=r("1139de1233fd67f45bd7");var a=r("5f25c015bbbf9d42c661");var c=r("d34390b928ecadc11dc8");var o=r("273d2eedcd369c189e70")("src");var i="toString";var f=Function[i];var u=(""+f).split(i);r("5925dad3c5243ffee3db").inspectSource=function(e){return f.call(e)};(e.exports=function(e,t,r,i){var f="function"==typeof r;if(f)c(r,"name")||a(r,"name",t);if(e[t]===r)return;if(f)c(r,o)||a(r,o,e[t]?""+e[t]:u.join(String(t)));if(e===n)e[t]=r;else if(!i){delete e[t];a(e,t,r)}else if(e[t])e[t]=r;else a(e,t,r)})(Function.prototype,i,(function e(){return"function"==typeof this&&this[o]||f.call(this)}))},"896f33738142bf70015e":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("1e0f00d296712713afe6");n(n.P+n.F*!r("40b064d4eb439c0c1c2b")([].reduceRight,true),"Array",{reduceRight:function e(t){return a(this,t,arguments.length,arguments[1],true)}})},"89a21af31babcdc56725":function(e,t,r){"use strict";var n=r("1139de1233fd67f45bd7");var a=r("1b01d0e59d3af79760a0");var c=r("5975c7ea3ecd56e534e3");var o=r("621a65702ee1a566fd32")("species");e.exports=function(e){var t=n[e];if(c&&t&&!t[o])a.f(t,o,{configurable:true,get:function(){return this}})}},"8de492c765fbfb624515":function(e,t,r){"use strict";var n=r("1b01d0e59d3af79760a0");var a=r("9d5592e83ab7f3d08974");e.exports=function(e,t,r){if(t in e)n.f(e,t,a(0,r));else e[t]=r}},"8f648b1026e01323935b":function(e,t,r){var n=r("0116c75136b233002fb9");e.exports=Array.isArray||function e(t){return"Array"==n(t)}},"9125d51ebaa93f49cfd5":function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("ecd0e0fb36455021f082")(3);n(n.P+n.F*!r("40b064d4eb439c0c1c2b")([].some,true),"Array",{some:function e(t){return a(this,t,arguments[1])}})},"9d5592e83ab7f3d08974":function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},"9fbadcf2c98d054f245e":function(e,t,r){"use strict";var n=r("1b24b031f63a74d1f57f");var a=[ReferenceError,TypeError,RangeError];var c=false;t.disable=o;function o(){c=false;n._Y=null;n._Z=null}t.enable=i;function i(e){e=e||{};if(c)o();c=true;var t=0;var r=0;var i={};n._Y=function(e){if(2===e._V&&i[e._1]){if(i[e._1].logged)s(e._1);else clearTimeout(i[e._1].timeout);delete i[e._1]}};n._Z=function(e,r){if(0===e._U){e._1=t++;i[e._1]={displayId:null,error:r,timeout:setTimeout(d.bind(null,e._1),u(r,a)?100:2e3),logged:false}}};function d(t){if(e.allRejections||u(i[t].error,e.whitelist||a)){i[t].displayId=r++;if(e.onUnhandled){i[t].logged=true;e.onUnhandled(i[t].displayId,i[t].error)}else{i[t].logged=true;f(i[t].displayId,i[t].error)}}}function s(t){if(i[t].logged)if(e.onHandled)e.onHandled(i[t].displayId,i[t].error);else if(!i[t].onUnhandled){void 0;void 0}}}function f(e,t){void 0;var r=(t&&(t.stack||t))+"";r.split("\n").forEach((function(e){void 0}))}function u(e,t){return t.some((function(t){return e instanceof t}))}},a459ab805827640a27e8:function(e,t){e.exports=function(e){return"object"===typeof e?null!==e:"function"===typeof e}},a537d0accb907bf9d41f:function(e,t,r){var n=r("0116c75136b233002fb9");e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==n(e)?e.split(""):Object(e)}},a5e6f0092ff0290e0bcf:function(e,t,r){var n=r("621a65702ee1a566fd32")("unscopables");var a=Array.prototype;if(void 0==a[n])r("5f25c015bbbf9d42c661")(a,n,{});e.exports=function(e){a[n][e]=true}},a6444c69152f1487917b:function(e,t,r){r("340dbda6fe6f17098a91");r("cff317ca62d09454b2d3");r("0a5193b0534d54dbcda1");r("3f2012daa60f226e86ec");r("4cc77e026250beeef142");r("1b71f5e96f29a92413b6");r("5baa1143f58e62614ca0");r("0f025c284bc567debf3d");r("1591b90b4327c94245ad");r("0565be87d109f51269ca");r("9125d51ebaa93f49cfd5");r("cf802dc5a6982c8247e6");r("481c1f0e850b0c8d0f7d");r("896f33738142bf70015e");r("c9be824f185f52a1979a");r("1468f5d37f30f63d76ea");r("bc0f72eb2321587e4779");r("fa5cd10f53a62f249502");r("3932316ffef991f5d157");r("3fc8b4ca32b0aebd9ff3");r("74be682203e7c82cb4c9");r("307014e72ed12da69e15");e.exports=r("5925dad3c5243ffee3db").Array},a6d645856102faf17328:function(e,t,r){var n=r("1b01d0e59d3af79760a0");var a=r("79c91dcd8cd554c59c7b");var c=r("145c4f2bdc487b2578df");e.exports=r("5975c7ea3ecd56e534e3")?Object.defineProperties:function e(t,r){a(t);var o=c(r);var i=o.length;var f=0;var u;while(i>f)n.f(t,u=o[f++],r[u]);return t}},bc0f72eb2321587e4779:function(e,t,r){var n=r("2d13d93c336705cd8ff9");n(n.P,"Array",{copyWithin:r("06b2b473e53cc019ca74")});r("a5e6f0092ff0290e0bcf")("copyWithin")},bc1a333d2b6eceac22e3:function(e,t,r){e.exports=!r("5975c7ea3ecd56e534e3")&&!r("7a7739dd8a198a2cfcb5")((function(){return 7!=Object.defineProperty(r("68a989d6f90923909f2a")("div"),"a",{get:function(){return 7}}).a}))},c9be824f185f52a1979a:function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("2076e982c14c41925fb4")(false);var c=[].indexOf;var o=!!c&&1/[1].indexOf(1,-0)<0;n(n.P+n.F*(o||!r("40b064d4eb439c0c1c2b")(c)),"Array",{indexOf:function e(t){return o?c.apply(this,arguments)||0:a(this,t,arguments[1])}})},ca19e32ab6ee3b3692aa:function(e,t,r){var n=r("1f3157d073736826d4fa");var a=Math.min;e.exports=function(e){return e>0?a(n(e),9007199254740991):0}},cf802dc5a6982c8247e6:function(e,t,r){"use strict";var n=r("2d13d93c336705cd8ff9");var a=r("ecd0e0fb36455021f082")(4);n(n.P+n.F*!r("40b064d4eb439c0c1c2b")([].every,true),"Array",{every:function e(t){return a(this,t,arguments[1])}})},cff317ca62d09454b2d3:function(e,t,r){var n=r("2d13d93c336705cd8ff9");n(n.S,"Array",{isArray:r("8f648b1026e01323935b")})},d34390b928ecadc11dc8:function(e,t){var r={}.hasOwnProperty;e.exports=function(e,t){return r.call(e,t)}},d394d0a4c1838202489d:function(e,t,r){var n=r("7ad2c0eb9a8edcc472a4");e.exports=function(e){return Object(n(e))}},dabaabbe8ba08d59975f:function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},e0b8897ffbf48a102fbb:function(e,t,r){"use strict";r.d(t,"b",(function(){return f}));r.d(t,"c",(function(){return u}));r.d(t,"d",(function(){return d}));r.d(t,"f",(function(){return s}));r.d(t,"e",(function(){return v}));r.d(t,"o",(function(){return l}));r.d(t,"l",(function(){return b}));r.d(t,"j",(function(){return h}));r.d(t,"i",(function(){return p}));r.d(t,"m",(function(){return y}));r.d(t,"k",(function(){return m}));r.d(t,"g",(function(){return g}));r.d(t,"h",(function(){return w}));r.d(t,"a",(function(){return x}));r.d(t,"n",(function(){return _}));var n="production"!=="production";var a="VA"==="TTP";var c="VA"==="VA";var o=a?"https://lf16-tiktok-web.tiktokcdn-us.com":"https://lf16-tiktok-web.ttwstatic.com";var i=a?"/obj/tiktok-web-tx/tiktok/falcon/embed":c?"/obj/tiktok-web-us/tiktok/falcon/embed":"/obj/tiktok-web/tiktok/falcon/embed";var f=n?"http://127.0.0.1:4000":"".concat(o).concat(i);var u="ttEmbedLibCSS";var d="ttEmbedLibScript";var s="embed_lib_v";var v=r("40b8419e3e2132ef0a63").version;var l="https://www.tiktok.com";var b="blockquote";var h="tiktokEmbed";var p="tiktok-embed";var y="message";var m="__tt_embed__";var g="mounting";var w="newmount";var x=Object.freeze({CREATOR:"creator",VIDEO:"video",TAG:"tag",MUSIC:"music",TRENDING:"trending",CURATED:"curated"});var _={TTP:["https://www.tiktok.com","https://lf16-tiktok-common.tiktokcdn-us.com","https://vmweb.us.tiktok.com"],VA:["https://www.tiktok.com","https://lf16-tiktok-common.ttwstatic.com","https://vmweb-va.byteoversea.com"],SG:["https://www.tiktok.com","https://lf16-tiktok-common.ttwstatic.com","https://vmweb-sg.byteoversea.com"],Default:["https://www.tiktok.com","https://lf16-tiktok-common.tiktokcdn-us.com","https://vmweb.us.tiktok.com"]}},e3136eea77d23f8d97ec:function(e,t,r){var n=r("d34390b928ecadc11dc8");var a=r("efae14a3f8cd9a616256");var c=r("2076e982c14c41925fb4")(false);var o=r("5f6eded14a8ed86276fc")("IE_PROTO");e.exports=function(e,t){var r=a(e);var i=0;var f=[];var u;for(u in r)if(u!=o)n(r,u)&&f.push(u);while(t.length>i)if(n(r,u=t[i++]))~c(f,u)||f.push(u);return f}},e6615fafe8e11b81e37a:function(e,t,r){"use strict";var n=r("1b24b031f63a74d1f57f");e.exports=n;var a=d(true);var c=d(false);var o=d(null);var i=d(void 0);var f=d(0);var u=d("");function d(e){var t=new n(n._0);t._V=1;t._W=e;return t}n.resolve=function(e){if(e instanceof n)return e;if(null===e)return o;if(void 0===e)return i;if(true===e)return a;if(false===e)return c;if(0===e)return f;if(""===e)return u;if("object"===typeof e||"function"===typeof e)try{var t=e.then;if("function"===typeof t)return new n(t.bind(e))}catch(r){return new n((function(e,t){t(r)}))}return d(e)};var s=function(e){if("function"===typeof Array.from){s=Array.from;return Array.from(e)}s=function(e){return Array.prototype.slice.call(e)};return Array.prototype.slice.call(e)};n.all=function(e){var t=s(e);return new n((function(e,r){if(0===t.length)return e([]);var a=t.length;function c(o,i){if(i&&("object"===typeof i||"function"===typeof i))if(i instanceof n&&i.then===n.prototype.then){while(3===i._V)i=i._W;if(1===i._V)return c(o,i._W);if(2===i._V)r(i._W);i.then((function(e){c(o,e)}),r);return}else{var f=i.then;if("function"===typeof f){var u=new n(f.bind(i));u.then((function(e){c(o,e)}),r);return}}t[o]=i;if(0===--a)e(t)}for(var o=0;o<t.length;o++)c(o,t[o])}))};n.reject=function(e){return new n((function(t,r){r(e)}))};n.race=function(e){return new n((function(t,r){s(e).forEach((function(e){n.resolve(e).then(t,r)}))}))};n.prototype["catch"]=function(e){return this.then(null,e)}},ecd0e0fb36455021f082:function(e,t,r){var n=r("0e717e1f47872428608d");var a=r("a537d0accb907bf9d41f");var c=r("d394d0a4c1838202489d");var o=r("ca19e32ab6ee3b3692aa");var i=r("0594430ce9777a0767aa");e.exports=function(e,t){var r=1==e;var f=2==e;var u=3==e;var d=4==e;var s=6==e;var v=5==e||s;var l=t||i;return function(t,i,b){var h=c(t);var p=a(h);var y=n(i,b,3);var m=o(p.length);var g=0;var w=r?l(t,m):f?l(t,0):void 0;var x,_;for(;m>g;g++)if(v||g in p){x=p[g];_=y(x,g,h);if(e)if(r)w[g]=_;else if(_)switch(e){case 3:return true;case 5:return x;case 6:return g;case 2:w.push(x)}else if(d)return false}return s?-1:u||d?d:w}}},ef09ce044ac3210bc947:function(e,t,r){var n=r("79c91dcd8cd554c59c7b");var a=r("a6d645856102faf17328");var c=r("380c0734c088ca78ccda");var o=r("5f6eded14a8ed86276fc")("IE_PROTO");var i=function(){};var f="prototype";var u=function(){var e=r("68a989d6f90923909f2a")("iframe");var t=c.length;var n="<";var a=">";var o;e.style.display="none";r("5b9dc0e027f5c68eff1a").appendChild(e);e.src="javascript:";o=e.contentWindow.document;o.open();o.write(n+"script"+a+"document.F=Object"+n+"/script"+a);o.close();u=o.F;while(t--)delete u[f][c[t]];return u()};e.exports=Object.create||function e(t,r){var c;if(null!==t){i[f]=n(t);c=new i;i[f]=null;c[o]=t}else c=u();return void 0===r?c:a(c,r)}},efae14a3f8cd9a616256:function(e,t,r){var n=r("a537d0accb907bf9d41f");var a=r("7ad2c0eb9a8edcc472a4");e.exports=function(e){return n(a(e))}},f88518adc3004bf8d923:function(e,t,r){var n=r("32b716d95af2fd3c5c23");var a=r("621a65702ee1a566fd32")("iterator");var c=r("224ae09e536c09e69a0a");e.exports=r("5925dad3c5243ffee3db").getIteratorMethod=function(e){if(void 0!=e)return e[a]||e["@@iterator"]||c[n(e)]}},f8f08bdd917755ac017a:function(e,t,r){"use strict";(function(t){e.exports=r;function r(e){if(!n.length){c();a=true}n[n.length]=e}var n=[];var a=false;var c;var o=0;var i=1024;function f(){while(o<n.length){var e=o;o+=1;n[e].call();if(o>i){for(var t=0,r=n.length-o;t<r;t++)n[t]=n[t+o];n.length-=o;o=0}}n.length=0;o=0;a=false}var u="undefined"!==typeof t?t:self;var d=u.MutationObserver||u.WebKitMutationObserver;if("function"===typeof d)c=s(f);else c=v(f);r.requestFlush=c;function s(e){var t=1;var r=new d(e);var n=document.createTextNode("");r.observe(n,{characterData:true});return function e(){t=-t;n.data=t}}function v(e){return function t(){var r=setTimeout(a,0);var n=setInterval(a,50);function a(){clearTimeout(r);clearInterval(n);e()}}}r.makeRequestCallFromTimer=v}).call(this,r("43382cd620aa5a0df057"))},fa5cd10f53a62f249502:function(e,t,r){var n=r("2d13d93c336705cd8ff9");n(n.P,"Array",{fill:r("03192b087bb464f059c0")});r("a5e6f0092ff0290e0bcf")("fill")}});
          }, 200);

        // document.querySelector('.cursor__pointer__drag svg').classList.remove('hover');


          all();


        },

        leave: function (data) {
        },
        enter: function (data) {
        },
      },
    ],
  });

  barba.hooks.afterLeave((data) => {

    const remove_after = data.next.html.indexOf('" id="body"'),
        result =  data.next.html.substring(0, remove_after),
        result_2 = result.substring(result.indexOf("<body class=") + 13);

    document.body.setAttribute("class", result_2);

    if (!match || !match[1]) {
      // If no body class, remove it
      document.body.setAttribute("class", "");
    } else {
      // Set the new body class
      document.body.setAttribute("class", result);
    }
  });

  barba.hooks.enter(() => {

    window.scrollTo(0, 0);
  });

};



